// Auto-generated curriculum data
// Covers CBSE (NCERT), ICSE (CISCE), and TN Samacheer Kalvi — Grades 1–12

export const BOARD_LABELS = {
  CBSE: "CBSE (NCERT)",
  ICSE: "ICSE / ISC",
  TN_SAMACHEER: "TN Samacheer Kalvi",
};

export const GRADES = Array.from({ length: 12 }, (_, i) => i + 1);

export const CURRICULUM_TEMPLATES = {
  "CBSE": {
    "1": [
      {
        "name": "Mathematics",
        "chapters": [
          "Shapes and Space",
          "Numbers from One to Nine",
          "Addition",
          "Subtraction",
          "Numbers from Ten to Twenty",
          "Time",
          "Measurement",
          "Numbers from Twenty-one to Fifty",
          "Data Handling",
          "Patterns",
          "Numbers",
          "Money",
          "How Many"
        ]
      },
      {
        "name": "English (Marigold)",
        "chapters": [
          "A Happy Child / Three Little Pigs",
          "After a Bath / The Bubble the Straw and the Shoe",
          "One Little Kitten / Lalu and Peelu",
          "Once I Saw a Little Bird / Mittu and the Yellow Mango",
          "Merry-Go-Round / Circle",
          "If I Were an Apple / Our Tree",
          "A Kite / Sundari",
          "A Little Turtle / The Tiger and the Mosquito",
          "Clouds / Anandi's Rainbow",
          "Flying-Man / The Tailor and his Friend"
        ]
      },
      {
        "name": "Hindi (Rimjhim)",
        "chapters": [
          "झूला",
          "आम की कहानी",
          "आम की टोकरी",
          "पत्ते ही पत्ते",
          "पकौड़ी",
          "छुक-छुक गाड़ी",
          "रसोईघर",
          "चूहो! म्याऊँ सो रही है",
          "बंदर और गिलहरी",
          "पगड़ी",
          "पतंग",
          "गेंद-बल्ला",
          "बंदर गया खेत में भाग",
          "एक बुढ़िया"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "My Family",
          "My Body",
          "Plants Around Us",
          "Animals Around Us",
          "Food We Eat",
          "Water",
          "Weather and Seasons",
          "Our Helpers",
          "Transport",
          "Communication"
        ]
      }
    ],
    "2": [
      {
        "name": "Mathematics",
        "chapters": [
          "What is Long, What is Round?",
          "Counting in Groups",
          "How Much Can You Carry?",
          "Counting in Tens",
          "The Junk Seller",
          "Jugs and Mugs",
          "Tens and Ones",
          "My Funday",
          "Lines and Lines",
          "Give and Take",
          "The Longest Step",
          "Birds Come",
          "How Many Ponytails?"
        ]
      },
      {
        "name": "English (Marigold)",
        "chapters": [
          "First Day at School / Haldi's Adventure",
          "I am Lucky! / I Want",
          "A Smile / The Wind and the Sun",
          "Rain / Storm in the Garden",
          "Zoo Manners / Funny Bunny",
          "Mr. Nobody / Curlylocks and the Three Bears",
          "On My Blackboard I Can Draw / Make it Shorter",
          "I am the Music Man / The Mumbai Musicians",
          "Granny Granny Please Comb My Hair / The Magic Porridge Pot",
          "Strange Talk / The Scholars Mother Tongue"
        ]
      },
      {
        "name": "Hindi (Rimjhim)",
        "chapters": [
          "ऊँट चला",
          "भालू ने खेली फुटबॉल",
          "म्याऊँ-म्याऊँ!!",
          "अधिक बलवान कौन?",
          "दोस्त की मदद",
          "बहुत हुआ",
          "मेरी किताब",
          "तितली और कली",
          "बुलबुल",
          "मेढक की दिलचस्प कहानी",
          "टेसू राजा बीच बाज़ार",
          "बोलनेवाली गुफा",
          "सूरज जल्दी आना जी",
          "नटखट चूहा",
          "एक्की-दोक्की"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "Plants and Animals",
          "Our School",
          "Our Family",
          "Food",
          "Good Habits",
          "Cleanliness",
          "Our Body",
          "Water",
          "Air",
          "Weather",
          "Transport",
          "Our Earth"
        ]
      }
    ],
    "3": [
      {
        "name": "Mathematics",
        "chapters": [
          "Where to Look For",
          "Fun with Numbers",
          "Give and Take",
          "Long and Short",
          "Shapes and Designs",
          "Fun with Give and Take",
          "Time Goes On",
          "Who is Heavier?",
          "How Many Times?",
          "Play with Patterns",
          "Jugs and Mugs",
          "Can We Share?",
          "Smart Charts",
          "Rupees and Paise"
        ]
      },
      {
        "name": "English (Marigold)",
        "chapters": [
          "Good Morning / The Magic Garden",
          "Bird Talk / Nina and the Baby Sparrows",
          "The Enormous Turnip / Sea Song",
          "A Little Fish Story / Sea Song (continued)",
          "The Balloon Man / Punter the Youngest Camel",
          "Trains / The Story of the Road",
          "Little Tiger Big Tiger / An Odd Fish",
          "My silly Sister / Wings",
          "He is my Brother / Nine Gold Medals",
          "How Creatures Move / The Ship of the Desert"
        ]
      },
      {
        "name": "Hindi (Rimjhim)",
        "chapters": [
          "कक्कू",
          "शेखीबाज़ मक्खी",
          "चाँद वाली अम्मा",
          "मन करता है",
          "बहादुर बित्तो",
          "हमसे सब कहते",
          "टिपटिपवा",
          "बंदर बाँट",
          "अक्ल बड़ी या भैंस",
          "क्योंकि",
          "मीठी सारंगी",
          "जब मुझे साँप ने काटा",
          "मिर्च का मज़ा",
          "सबसे अच्छा पेड़"
        ]
      },
      {
        "name": "Environmental Studies (Looking Around)",
        "chapters": [
          "Poonam's Day Out",
          "The Plant Fairy",
          "Water",
          "Our First School",
          "Chhotu's House",
          "Foods We Eat",
          "Saying Without Speaking",
          "Flying High",
          "It's Raining",
          "What is Cooking?",
          "From Here to There",
          "Work We Do",
          "Sharing Our Feelings",
          "The Story of Food",
          "Making Pots",
          "Games We Play",
          "Here Comes the Letter",
          "A House Like This",
          "Our Friends Animals",
          "Drop by Drop",
          "Families Can Be Different",
          "Left Right",
          "A Beautiful Cloth",
          "Try This Out"
        ]
      }
    ],
    "4": [
      {
        "name": "Mathematics",
        "chapters": [
          "Building with Bricks",
          "Long and Short",
          "A Trip to Bhopal",
          "Tick-Tick-Tick",
          "The Way the World Looks",
          "The Junk Seller",
          "Jugs and Mugs",
          "Carts and Wheels",
          "Halves and Quarters",
          "Play with Patterns",
          "Tables and Shares",
          "How Heavy? How Light?",
          "Fields and Fences",
          "Smart Charts"
        ]
      },
      {
        "name": "English (Marigold)",
        "chapters": [
          "Wake Up! / Neha's Alarm Clock",
          "Noses / The Little Fir Tree",
          "Run! / Nasruddin's Aim",
          "Why? / Alice in Wonderland",
          "Don't be Afraid of the Dark / Helen Keller",
          "Hiawatha / The Scholar's Mother Tongue",
          "A Watering Rhyme / The Giving Tree",
          "Books / Going to Buy a Book",
          "The Naughty Boy / Pinocchio",
          "Run! / Topsy-Turvy Land"
        ]
      },
      {
        "name": "Hindi (Rimjhim)",
        "chapters": [
          "मन के भोले-भाले बादल",
          "जैसा सवाल वैसा जवाब",
          "किरमिच की गेंद",
          "पापा जब बच्चे थे",
          "दोस्त की पोशाक",
          "नाव बनाओ नाव बनाओ",
          "दान का हिसाब",
          "कौन?",
          "स्वतंत्रता की ओर",
          "थप्प रोटी थप्प दाल",
          "पढ़क्कू की सूझ",
          "सुनीता की पहिया कुर्सी",
          "हुदहुद",
          "मुफ़्त ही मुफ़्त"
        ]
      },
      {
        "name": "Environmental Studies (Looking Around)",
        "chapters": [
          "Going to School",
          "Ear to Ear",
          "A Day with Nandu",
          "The Story of Amrita",
          "Anita and the Honeybees",
          "Omana's Journey",
          "From the Window",
          "Reaching Grandmother's House",
          "Changing Families",
          "Hu Tu Tu Hu Tu Tu",
          "The Valley of Flowers",
          "Changing Times",
          "A River's Tale",
          "Basva's Farm",
          "From Market to Home",
          "A Busy Month",
          "Nandita in Mumbai",
          "Too Much Water Too Little Water",
          "Abdul in the Garden",
          "Eating Together",
          "Food and Fun",
          "The World in My Home",
          "A Small Family a Happy Family",
          "How We Celebrate",
          "Like Father Like Daughter"
        ]
      }
    ],
    "5": [
      {
        "name": "Mathematics",
        "chapters": [
          "The Fish Tale",
          "Shapes and Angles",
          "How Many Squares?",
          "Parts and Wholes",
          "Does it Look the Same?",
          "Be My Multiple I'll be Your Factor",
          "Can You See the Pattern?",
          "Mapping Your Way",
          "Boxes and Sketches",
          "Tenths and Hundredths",
          "Area and its Boundary",
          "Smart Charts",
          "Ways to Multiply and Divide",
          "How Big? How Heavy?"
        ]
      },
      {
        "name": "English (Marigold)",
        "chapters": [
          "Ice-Cream Man / Wonderful Waste",
          "Teamwork / Flying Together",
          "My Shadow / Robinson Crusoe",
          "Crying / My Elder Brother",
          "The Lazy Frog / Rip Van Winkle",
          "Class Discussion / The Talkative Barber",
          "Topsy-Turvy Land / Gulliver's Travels",
          "Nobody's Friend / The Little Bully",
          "Sing a Song of People / Around the World",
          "Malu Bhalu / Who Will be Ningthou?"
        ]
      },
      {
        "name": "Hindi (Rimjhim)",
        "chapters": [
          "राख की रस्सी",
          "फ़सलों के त्योहार",
          "खिलौनेवाला",
          "नन्हा फ़नकार",
          "जहाँ चाह वहाँ राह",
          "चिट्ठी का सफ़र",
          "डाकिए की कहानी, कँवरसिंह की ज़ुबानी",
          "वे दिन भी क्या दिन थे",
          "एक माँ की बेबसी",
          "एक दिन की बादशाहत",
          "चावल की रोटियाँ",
          "गुरु और चेला",
          "स्वामी की दादी",
          "बाघ आया उस रात",
          "बिशन की दिलेरी",
          "पानी रे पानी",
          "छोटी-सी हमारी नदी",
          "चुनौती हिमालय की"
        ]
      },
      {
        "name": "Environmental Studies (Looking Around)",
        "chapters": [
          "Super Senses",
          "A Snake Charmer's Story",
          "From Tasting to Digesting",
          "Mangoes Round the Year",
          "Seeds and Seeds",
          "Every Drop Counts",
          "Experiments with Water",
          "A Treat for Mosquitoes",
          "Up You Go!",
          "Walls Tell Stories",
          "Sunita in Space",
          "What if it Finishes...?",
          "A Shelter so High!",
          "When the Earth Shook!",
          "Blow Hot Blow Cold",
          "Who will do this Work?",
          "Across the Wall",
          "No Place for Us?",
          "A Seed Tells a Farmer's Story",
          "Whose Forests?",
          "Like Father Like Daughter",
          "On the Move Again"
        ]
      }
    ],
    "6": [
      {
        "name": "Mathematics",
        "chapters": [
          "Knowing Our Numbers",
          "Whole Numbers",
          "Playing with Numbers",
          "Basic Geometrical Ideas",
          "Understanding Elementary Shapes",
          "Integers",
          "Fractions",
          "Decimals",
          "Data Handling",
          "Mensuration",
          "Algebra",
          "Ratio and Proportion",
          "Symmetry",
          "Practical Geometry"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Food: Where Does It Come From?",
          "Components of Food",
          "Fibre to Fabric",
          "Sorting Materials into Groups",
          "Separation of Substances",
          "Changes Around Us",
          "Getting to Know Plants",
          "Body Movements",
          "The Living Organisms and Their Surroundings",
          "Motion and Measurement of Distances",
          "Light, Shadows and Reflections",
          "Electricity and Circuits",
          "Fun with Magnets",
          "Water",
          "Air Around Us",
          "Garbage In, Garbage Out"
        ]
      },
      {
        "name": "History (Our Pasts)",
        "chapters": [
          "What, Where, How and When?",
          "On the Trail of the Earliest People",
          "From Gathering to Growing Food",
          "In the Earliest Cities",
          "What Books and Burials Tell Us",
          "Kingdoms, Kings and an Early Republic",
          "New Questions and Ideas",
          "Ashoka, the Emperor Who Gave Up War",
          "Vital Villages, Thriving Towns",
          "Traders, Kings and Pilgrims",
          "New Empires and Kingdoms",
          "Buildings, Paintings and Books"
        ]
      },
      {
        "name": "Geography (The Earth: Our Habitat)",
        "chapters": [
          "The Earth in the Solar System",
          "Globe: Latitudes and Longitudes",
          "Motions of the Earth",
          "Maps",
          "Major Domains of the Earth",
          "Major Landforms of the Earth",
          "Our Country – India",
          "India: Climate, Vegetation and Wildlife"
        ]
      },
      {
        "name": "Civics (Social and Political Life)",
        "chapters": [
          "Understanding Diversity",
          "Diversity and Discrimination",
          "What is Government?",
          "Key Elements of a Democratic Government",
          "Panchayati Raj",
          "Rural Administration",
          "Urban Administration",
          "Rural Livelihoods",
          "Urban Livelihoods"
        ]
      },
      {
        "name": "English (Honeysuckle)",
        "chapters": [
          "Who Did Patrick's Homework?",
          "How the Dog Found Himself a New Master!",
          "Taro's Reward",
          "An Indian – American Woman in Space: Kalpana Chawla",
          "A Different Kind of School",
          "Who I Am",
          "Fair Play",
          "A Game of Chance",
          "Desert Animals",
          "The Banyan Tree"
        ]
      },
      {
        "name": "Hindi (Vasant)",
        "chapters": [
          "वह चिड़िया जो",
          "बचपन",
          "नादान दोस्त",
          "चाँद से थोड़ी-सी गप्पें",
          "अक्षरों का महत्व",
          "पार नज़र के",
          "साथी हाथ बढ़ाना",
          "ऐसे–ऐसे",
          "टिकट-अलबम",
          "झाँसी की रानी",
          "जो देखकर भी नहीं देखते",
          "संसार पुस्तक है",
          "मैं सबसे छोटी होऊँ",
          "लोकगीत",
          "नौकर",
          "वन के मार्ग में",
          "साँस-साँस में बाँस"
        ]
      },
      {
        "name": "Computer Science",
        "chapters": [
          "Introduction to Computers",
          "History of Computers",
          "Hardware and Software",
          "Input and Output Devices",
          "Memory",
          "Introduction to Windows",
          "MS Word - Basics",
          "MS Word - Formatting",
          "MS Paint",
          "Introduction to the Internet"
        ]
      }
    ],
    "7": [
      {
        "name": "Mathematics",
        "chapters": [
          "Integers",
          "Fractions and Decimals",
          "Data Handling",
          "Simple Equations",
          "Lines and Angles",
          "The Triangle and its Properties",
          "Congruence of Triangles",
          "Comparing Quantities",
          "Rational Numbers",
          "Practical Geometry",
          "Perimeter and Area",
          "Algebraic Expressions",
          "Exponents and Powers",
          "Symmetry",
          "Visualising Solid Shapes"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Nutrition in Plants",
          "Nutrition in Animals",
          "Fibre to Fabric",
          "Heat",
          "Acids, Bases and Salts",
          "Physical and Chemical Changes",
          "Weather, Climate and Adaptations of Animals to Climate",
          "Winds, Storms and Cyclones",
          "Soil",
          "Respiration in Organisms",
          "Transportation in Animals and Plants",
          "Reproduction in Plants",
          "Motion and Time",
          "Electric Current and Its Effects",
          "Light",
          "Water: A Precious Resource",
          "Forests: Our Lifeline",
          "Wastewater Story"
        ]
      },
      {
        "name": "History (Our Pasts II)",
        "chapters": [
          "Tracing Changes Through a Thousand Years",
          "New Kings and Kingdoms",
          "The Delhi Sultans",
          "The Mughal Empire",
          "Rulers and Buildings",
          "Towns, Traders and Craftspersons",
          "Tribes, Nomads and Settled Communities",
          "Devotional Paths to the Divine",
          "The Making of Regional Cultures",
          "Eighteenth-Century Political Formations"
        ]
      },
      {
        "name": "Geography (Our Environment)",
        "chapters": [
          "Environment",
          "Inside Our Earth",
          "Our Changing Earth",
          "Air",
          "Water",
          "Natural Vegetation and Wildlife",
          "Human Environment – Settlement, Transport and Communication",
          "Human-Environment Interactions – The Tropical and the Subtropical Region",
          "Life in the Temperate Grasslands",
          "Life in the Deserts"
        ]
      },
      {
        "name": "Civics (Social and Political Life II)",
        "chapters": [
          "On Equality",
          "Role of the Government in Health",
          "How the State Government Works",
          "Growing Up as Boys and Girls",
          "Women Change the World",
          "Understanding Media",
          "Markets Around Us",
          "A Shirt in the Market",
          "Struggles for Equality"
        ]
      },
      {
        "name": "English (Honeycomb)",
        "chapters": [
          "Three Questions",
          "A Gift of Chappals",
          "Gopal and the Hilsa Fish",
          "The Ashes That Made Trees Bloom",
          "Quality",
          "Expert Detectives",
          "The Invention of Vita-Wonk",
          "Fire: Friend and Foe",
          "A Bicycle in Good Repair",
          "The Story of Cricket"
        ]
      },
      {
        "name": "Hindi (Vasant)",
        "chapters": [
          "हम पंछी उन्मुक्त गगन के",
          "दादी माँ",
          "हिमालय की बेटियाँ",
          "कठपुतली",
          "मिठाईवाला",
          "रक्त और हमारा शरीर",
          "पापा खो गए",
          "शाम – एक किसान",
          "चिड़िया की बच्ची",
          "अपूर्व अनुभव",
          "रहीम के दोहे",
          "कंचा",
          "एक तिनका",
          "खानपान की बदलती तसवीर",
          "नीलकंठ",
          "भोर और बरखा",
          "वीर कुँवर सिंह",
          "संघर्ष के कारण मैं तुनुकमिज़ाज हो गया",
          "आश्रम का अनुमानित व्यय",
          "विप्लव-गायन"
        ]
      },
      {
        "name": "Computer Science",
        "chapters": [
          "Computer Organisation",
          "Representation of Data",
          "Number Systems",
          "Introduction to MS Office",
          "MS Word - Advanced",
          "MS Excel - Basics",
          "MS PowerPoint",
          "Introduction to Programming",
          "HTML Basics",
          "Internet and Email"
        ]
      }
    ],
    "8": [
      {
        "name": "Mathematics",
        "chapters": [
          "Rational Numbers",
          "Linear Equations in One Variable",
          "Understanding Quadrilaterals",
          "Practical Geometry",
          "Data Handling",
          "Squares and Square Roots",
          "Cubes and Cube Roots",
          "Comparing Quantities",
          "Algebraic Expressions and Identities",
          "Visualising Solid Shapes",
          "Mensuration",
          "Exponents and Powers",
          "Direct and Inverse Proportions",
          "Factorisation",
          "Introduction to Graphs",
          "Playing with Numbers"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Crop Production and Management",
          "Microorganisms: Friend and Foe",
          "Synthetic Fibres and Plastics",
          "Materials: Metals and Non-Metals",
          "Coal and Petroleum",
          "Combustion and Flame",
          "Conservation of Plants and Animals",
          "Cell – Structure and Functions",
          "Reproduction in Animals",
          "Reaching the Age of Adolescence",
          "Force and Pressure",
          "Friction",
          "Sound",
          "Chemical Effects of Electric Current",
          "Some Natural Phenomena",
          "Light",
          "Stars and the Solar System",
          "Pollution of Air and Water"
        ]
      },
      {
        "name": "History (Our Pasts III)",
        "chapters": [
          "How, When and Where",
          "From Trade to Territory: The Company Establishes Power",
          "Ruling the Countryside",
          "Tribals, Dikus and the Vision of a Golden Age",
          "When People Rebel: 1857 and After",
          "Weavers, Iron Smelters and Factory Owners",
          "Civilising the 'Native', Educating the Nation",
          "Women, Caste and Reform",
          "The Making of the National Movement: 1870s–1947",
          "India After Independence"
        ]
      },
      {
        "name": "Geography (Resources and Development)",
        "chapters": [
          "Resources",
          "Land, Soil, Water, Natural Vegetation and Wildlife",
          "Mineral and Power Resources",
          "Agriculture",
          "Industries",
          "Human Resources"
        ]
      },
      {
        "name": "Civics (Social and Political Life III)",
        "chapters": [
          "The Indian Constitution",
          "Understanding Secularism",
          "Why Do We Need a Parliament?",
          "Understanding Laws",
          "Judiciary",
          "Understanding Our Criminal Justice System",
          "Understanding Marginalisation",
          "Confronting Marginalisation",
          "Public Facilities",
          "Law and Social Justice"
        ]
      },
      {
        "name": "English (Honeydew)",
        "chapters": [
          "The Best Christmas Present in the World",
          "The Tsunami",
          "Glimpses of the Past",
          "Bepin Choudhury's Lapse of Memory",
          "The Summit Within",
          "This is Jody's Fawn",
          "A Visit to Cambridge",
          "A Short Monsoon Diary",
          "The Great Stone Face I",
          "The Great Stone Face II"
        ]
      },
      {
        "name": "Hindi (Vasant)",
        "chapters": [
          "ध्वनि",
          "लाख की चूड़ियाँ",
          "बस की यात्रा",
          "दीवानों की हस्ती",
          "चिट्ठियों की अनूठी दुनिया",
          "भगवान के डाकिए",
          "क्या निराश हुआ जाए",
          "यह सबसे कठिन समय नहीं",
          "कबीर की साखियाँ",
          "कामचोर",
          "जब सिनेमा ने बोलना सीखा",
          "सुदामा चरित",
          "जहाँ पहिया है",
          "अकबरी लोटा",
          "सूर के पद",
          "पानी की कहानी",
          "बाज और साँप",
          "टोपी"
        ]
      },
      {
        "name": "Computer Science",
        "chapters": [
          "Advanced HTML",
          "Introduction to CSS",
          "Introduction to JavaScript",
          "MS Excel - Advanced",
          "Database Concepts",
          "Introduction to SQL",
          "Networking Basics",
          "Cyber Safety",
          "Scratch Programming",
          "Introduction to Python"
        ]
      }
    ],
    "9": [
      {
        "name": "Mathematics",
        "chapters": [
          "Number Systems",
          "Polynomials",
          "Coordinate Geometry",
          "Linear Equations in Two Variables",
          "Introduction to Euclid's Geometry",
          "Lines and Angles",
          "Triangles",
          "Quadrilaterals",
          "Areas of Parallelograms and Triangles",
          "Circles",
          "Constructions",
          "Heron's Formula",
          "Surface Areas and Volumes",
          "Statistics",
          "Probability"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Matter in Our Surroundings",
          "Is Matter Around Us Pure?",
          "Atoms and Molecules",
          "Structure of the Atom",
          "The Fundamental Unit of Life",
          "Tissues",
          "Diversity in Living Organisms",
          "Motion",
          "Force and Laws of Motion",
          "Gravitation",
          "Work and Energy",
          "Sound",
          "Why Do We Fall Ill?",
          "Natural Resources",
          "Improvement in Food Resources"
        ]
      },
      {
        "name": "History (India and the Contemporary World I)",
        "chapters": [
          "The French Revolution",
          "Socialism in Europe and the Russian Revolution",
          "Nazism and the Rise of Hitler",
          "Forest Society and Colonialism",
          "Pastoralists in the Modern World"
        ]
      },
      {
        "name": "Geography (Contemporary India I)",
        "chapters": [
          "India – Size and Location",
          "Physical Features of India",
          "Drainage",
          "Climate",
          "Natural Vegetation and Wildlife",
          "Population"
        ]
      },
      {
        "name": "Economics (Understanding Economic Development I)",
        "chapters": [
          "The Story of Village Palampur",
          "People as Resource",
          "Poverty as a Challenge",
          "Food Security in India"
        ]
      },
      {
        "name": "Political Science (Democratic Politics I)",
        "chapters": [
          "What is Democracy? Why Democracy?",
          "Constitutional Design",
          "Electoral Politics",
          "Working of Institutions",
          "Democratic Rights"
        ]
      },
      {
        "name": "English (Beehive)",
        "chapters": [
          "The Fun They Had",
          "The Sound of Music",
          "The Little Girl",
          "A Truly Beautiful Mind",
          "The Snake and the Mirror",
          "My Childhood",
          "Packing",
          "Reach for the Top",
          "The Bond of Love",
          "Kathmandu",
          "If I Were You"
        ]
      },
      {
        "name": "Hindi (Kshitij)",
        "chapters": [
          "दो बैलों की कथा",
          "ल्हासा की ओर",
          "उपभोक्तावाद की संस्कृति",
          "साँवले सपनों की याद",
          "नाना साहब की पुत्री देवी मैना को भस्म कर दिया गया",
          "प्रेमचंद के फटे जूते",
          "मेरे बचपन के दिन",
          "एक कुत्ता और एक मैना",
          "इस जल प्रलय में",
          "रैदास के पद",
          "रहीम के दोहे",
          "आदमी नामा",
          "एक फूल की चाह",
          "गीत-अगीत",
          "अग्नि पथ",
          "नए इलाके में / खुशबू रचते हैं हाथ"
        ]
      },
      {
        "name": "Computer Applications (Elective)",
        "chapters": [
          "Introduction to IT",
          "Number Systems",
          "Components of a Computer System",
          "Concept of Memory",
          "Input/Output Devices",
          "Software Concepts",
          "Basics of Operating System",
          "Word Processing",
          "Spreadsheets",
          "Presentations",
          "Internet and Email",
          "Digital Payments and Security",
          "Overview of Future Skills"
        ]
      }
    ],
    "10": [
      {
        "name": "Mathematics",
        "chapters": [
          "Real Numbers",
          "Polynomials",
          "Pair of Linear Equations in Two Variables",
          "Quadratic Equations",
          "Arithmetic Progressions",
          "Triangles",
          "Coordinate Geometry",
          "Introduction to Trigonometry",
          "Some Applications of Trigonometry",
          "Circles",
          "Constructions",
          "Areas Related to Circles",
          "Surface Areas and Volumes",
          "Statistics",
          "Probability"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Chemical Reactions and Equations",
          "Acids, Bases and Salts",
          "Metals and Non-metals",
          "Carbon and Its Compounds",
          "Life Processes",
          "Control and Coordination",
          "How do Organisms Reproduce?",
          "Heredity",
          "Light – Reflection and Refraction",
          "The Human Eye and the Colourful World",
          "Electricity",
          "Magnetic Effects of Electric Current",
          "Our Environment"
        ]
      },
      {
        "name": "History (India and the Contemporary World II)",
        "chapters": [
          "The Rise of Nationalism in Europe",
          "Nationalism in India",
          "The Making of a Global World",
          "The Age of Industrialisation",
          "Print Culture and the Modern World"
        ]
      },
      {
        "name": "Geography (Contemporary India II)",
        "chapters": [
          "Resources and Development",
          "Forest and Wildlife Resources",
          "Water Resources",
          "Agriculture",
          "Minerals and Energy Resources",
          "Manufacturing Industries",
          "Lifelines of National Economy"
        ]
      },
      {
        "name": "Economics (Understanding Economic Development II)",
        "chapters": [
          "Development",
          "Sectors of the Indian Economy",
          "Money and Credit",
          "Globalisation and the Indian Economy",
          "Consumer Rights"
        ]
      },
      {
        "name": "Political Science (Democratic Politics II)",
        "chapters": [
          "Power Sharing",
          "Federalism",
          "Gender, Religion and Caste",
          "Political Parties",
          "Outcomes of Democracy"
        ]
      },
      {
        "name": "English (First Flight)",
        "chapters": [
          "A Letter to God",
          "Nelson Mandela: Long Walk to Freedom",
          "Two Stories about Flying",
          "From the Diary of Anne Frank",
          "The Hundred Dresses – I",
          "The Hundred Dresses – II",
          "Glimpses of India",
          "Mijbil the Otter",
          "Madam Rides the Bus",
          "The Sermon at Benares",
          "The Proposal"
        ]
      },
      {
        "name": "Hindi (Kshitij II)",
        "chapters": [
          "सूरदास के पद",
          "राम-लक्ष्मण-परशुराम संवाद",
          "देव के सवैये और कवित्त",
          "जयशंकर प्रसाद – आत्मकथ्य",
          "सूर्यकांत त्रिपाठी निराला – उत्साह और अट नहीं रही",
          "नागार्जुन – यह दंतुरहित मुस्कान और फसल",
          "गिरिजा कुमार माथुर – छाया मत छूना",
          "ऋतुराज – कन्यादान",
          "मंगलेश डबराल – संगतकार",
          "स्वयं प्रकाश – नेताजी का चश्मा",
          "रामवृक्ष बेनीपुरी – बालगोबिन भगत",
          "यशपाल – लखनवी अंदाज़",
          "सर्वेश्वर दयाल सक्सेना – मानवीय करुणा की दिव्य चमक",
          "मन्नू भंडारी – एक कहानी यह भी",
          "महावीरप्रसाद द्विवेदी – स्त्री शिक्षा के विरोधी कुतर्कों का खंडन",
          "यतींद्र मिश्र – नौबतखाने में इबादत",
          "भदंत आनंद कौसल्यायन – संस्कृति"
        ]
      },
      {
        "name": "Computer Applications (Elective)",
        "chapters": [
          "Networking",
          "HTML and CSS",
          "More on HTML",
          "Introduction to XML",
          "Fundamentals of Python",
          "Python Data Types",
          "Conditional Statements in Python",
          "Loops in Python",
          "Functions in Python",
          "Python Libraries",
          "Cyber Ethics",
          "E-Commerce"
        ]
      }
    ],
    "11": [
      {
        "name": "Mathematics",
        "chapters": [
          "Sets",
          "Relations and Functions",
          "Trigonometric Functions",
          "Principle of Mathematical Induction",
          "Complex Numbers and Quadratic Equations",
          "Linear Inequalities",
          "Permutations and Combinations",
          "Binomial Theorem",
          "Sequences and Series",
          "Straight Lines",
          "Conic Sections",
          "Introduction to Three Dimensional Geometry",
          "Limits and Derivatives",
          "Mathematical Reasoning",
          "Statistics",
          "Probability"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Physical World",
          "Units and Measurement",
          "Motion in a Straight Line",
          "Motion in a Plane",
          "Laws of Motion",
          "Work, Energy and Power",
          "System of Particles and Rotational Motion",
          "Gravitation",
          "Mechanical Properties of Solids",
          "Mechanical Properties of Fluids",
          "Thermal Properties of Matter",
          "Thermodynamics",
          "Kinetic Theory",
          "Oscillations",
          "Waves"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Some Basic Concepts of Chemistry",
          "Structure of Atom",
          "Classification of Elements and Periodicity in Properties",
          "Chemical Bonding and Molecular Structure",
          "States of Matter: Gases and Liquids",
          "Thermodynamics",
          "Equilibrium",
          "Redox Reactions",
          "Hydrogen",
          "The s-Block Elements",
          "The p-Block Elements",
          "Organic Chemistry – Some Basic Principles and Techniques",
          "Hydrocarbons",
          "Environmental Chemistry"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "The Living World",
          "Biological Classification",
          "Plant Kingdom",
          "Animal Kingdom",
          "Morphology of Flowering Plants",
          "Anatomy of Flowering Plants",
          "Structural Organisation in Animals",
          "Cell: The Unit of Life",
          "Biomolecules",
          "Cell Cycle and Cell Division",
          "Photosynthesis in Higher Plants",
          "Respiration in Plants",
          "Plant Growth and Development",
          "Breathing and Exchange of Gases",
          "Body Fluids and Circulation",
          "Excretory Products and their Elimination",
          "Locomotion and Movement",
          "Neural Control and Coordination",
          "Chemical Coordination and Integration"
        ]
      },
      {
        "name": "Accountancy",
        "chapters": [
          "Introduction to Accounting",
          "Theory Base of Accounting",
          "Recording of Transactions – I",
          "Recording of Transactions – II",
          "Bank Reconciliation Statement",
          "Trial Balance and Rectification of Errors",
          "Depreciation, Provisions and Reserves",
          "Bill of Exchange",
          "Financial Statements – I",
          "Financial Statements – II",
          "Accounts from Incomplete Records",
          "Applications of Computers in Accounting",
          "Computerised Accounting System"
        ]
      },
      {
        "name": "Business Studies",
        "chapters": [
          "Nature and Purpose of Business",
          "Forms of Business Organisation",
          "Private, Public and Global Enterprises",
          "Business Services",
          "Emerging Modes of Business",
          "Social Responsibilities of Business and Business Ethics",
          "Formation of a Company",
          "Sources of Business Finance",
          "Small Business",
          "Internal Trade",
          "International Business"
        ]
      },
      {
        "name": "Economics",
        "chapters": [
          "Introduction to Microeconomics",
          "Theory of Consumer Behaviour",
          "Production and Costs",
          "The Theory of the Firm under Perfect Competition",
          "Market Equilibrium",
          "Non-Competitive Markets",
          "Introduction to Statistics",
          "Collection of Data",
          "Organisation of Data",
          "Presentation of Data",
          "Measures of Central Tendency",
          "Measures of Dispersion",
          "Correlation",
          "Index Numbers"
        ]
      },
      {
        "name": "History",
        "chapters": [
          "From the Beginning of Time",
          "Writing and City Life",
          "An Empire Across Three Continents",
          "The Central Islamic Lands",
          "Nomadic Empires",
          "The Three Orders",
          "Changing Cultural Traditions",
          "Confrontation of Cultures",
          "The Industrial Revolution",
          "Displacing Indigenous Peoples",
          "Paths to Modernisation"
        ]
      },
      {
        "name": "Political Science",
        "chapters": [
          "Political Theory: An Introduction",
          "Freedom",
          "Equality",
          "Social Justice",
          "Rights",
          "Citizenship",
          "Nationalism",
          "Secularism",
          "Peace",
          "Development"
        ]
      },
      {
        "name": "Geography (Fundamentals of Physical Geography)",
        "chapters": [
          "Geography as a Discipline",
          "The Origin and Evolution of the Earth",
          "Interior of the Earth",
          "Distribution of Oceans and Continents",
          "Minerals and Rocks",
          "Geomorphic Processes",
          "Fluvial Landforms",
          "Arid Landforms",
          "Glacial Landforms",
          "Coastal Landforms",
          "Atmosphere",
          "Solar Radiation, Heat Balance and Temperature",
          "Atmospheric Circulation and Weather Systems",
          "Water in the Atmosphere",
          "World Climate and Climate Change",
          "Water (Oceans)",
          "Movements of Ocean Water",
          "Biodiversity and Conservation"
        ]
      },
      {
        "name": "English (Hornbill)",
        "chapters": [
          "The Portrait of a Lady",
          "We're Not Afraid to Die...",
          "Discovering Tut: the Saga Continues",
          "Landscape of the Soul",
          "The Ailing Planet: the Green Movement's Role",
          "The Browning Version",
          "The Adventure",
          "Silk Road"
        ]
      },
      {
        "name": "Computer Science (Elective)",
        "chapters": [
          "Computer Systems and Organisation",
          "Encoding Schemes and Number System",
          "Emerging Trends",
          "Problem Solving",
          "Getting Started with Python",
          "Flow of Control",
          "Functions",
          "Strings",
          "Lists",
          "Tuples and Dictionaries",
          "Societal Impacts"
        ]
      },
      {
        "name": "Informatics Practices (Elective)",
        "chapters": [
          "Introduction to Computer System",
          "Introduction to Python",
          "Data Handling using NumPy",
          "Database Concepts",
          "Introduction to MySQL",
          "Aggregation Functions and Grouping",
          "Introduction to Emerging Technologies",
          "Societal Impacts"
        ]
      }
    ],
    "12": [
      {
        "name": "Mathematics",
        "chapters": [
          "Relations and Functions",
          "Inverse Trigonometric Functions",
          "Matrices",
          "Determinants",
          "Continuity and Differentiability",
          "Application of Derivatives",
          "Integrals",
          "Application of Integrals",
          "Differential Equations",
          "Vector Algebra",
          "Three Dimensional Geometry",
          "Linear Programming",
          "Probability"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Electric Charges and Fields",
          "Electrostatic Potential and Capacitance",
          "Current Electricity",
          "Moving Charges and Magnetism",
          "Magnetism and Matter",
          "Electromagnetic Induction",
          "Alternating Current",
          "Electromagnetic Waves",
          "Ray Optics and Optical Instruments",
          "Wave Optics",
          "Dual Nature of Radiation and Matter",
          "Atoms",
          "Nuclei",
          "Semiconductor Electronics: Materials, Devices and Simple Circuits"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "The Solid State",
          "Solutions",
          "Electrochemistry",
          "Chemical Kinetics",
          "Surface Chemistry",
          "General Principles and Processes of Isolation of Elements",
          "The p-Block Elements",
          "The d- and f-Block Elements",
          "Coordination Compounds",
          "Haloalkanes and Haloarenes",
          "Alcohols, Phenols and Ethers",
          "Aldehydes, Ketones and Carboxylic Acids",
          "Amines",
          "Biomolecules",
          "Polymers",
          "Chemistry in Everyday Life"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Reproduction in Organisms",
          "Sexual Reproduction in Flowering Plants",
          "Human Reproduction",
          "Reproductive Health",
          "Principles of Inheritance and Variation",
          "Molecular Basis of Inheritance",
          "Evolution",
          "Human Health and Disease",
          "Strategies for Enhancement in Food Production",
          "Microbes in Human Welfare",
          "Biotechnology: Principles and Processes",
          "Biotechnology and its Applications",
          "Organisms and Populations",
          "Ecosystem",
          "Biodiversity and Conservation",
          "Environmental Issues"
        ]
      },
      {
        "name": "Accountancy",
        "chapters": [
          "Accounting for Partnership: Basic Concepts",
          "Reconstitution of a Partnership Firm – Admission of a Partner",
          "Reconstitution of a Partnership Firm – Retirement/Death of a Partner",
          "Dissolution of Partnership Firm",
          "Accounting for Share Capital",
          "Issue and Redemption of Debentures",
          "Financial Statements of a Company",
          "Analysis of Financial Statements",
          "Accounting Ratios",
          "Cash Flow Statement"
        ]
      },
      {
        "name": "Business Studies",
        "chapters": [
          "Nature and Significance of Management",
          "Principles of Management",
          "Business Environment",
          "Planning",
          "Organising",
          "Staffing",
          "Directing",
          "Controlling",
          "Financial Management",
          "Financial Markets",
          "Marketing Management",
          "Consumer Protection",
          "Entrepreneurship Development"
        ]
      },
      {
        "name": "Economics",
        "chapters": [
          "National Income and Related Aggregates",
          "Money and Banking",
          "Determination of Income and Employment",
          "Government Budget and the Economy",
          "Balance of Payments",
          "Introduction to Indian Economy 1950–1990",
          "Indian Economy 1950–1990",
          "Economic Reforms Since 1991",
          "Current Challenges Facing Indian Economy",
          "Infrastructure",
          "Environment and Sustainable Development",
          "Comparative Development Experiences of India and Its Neighbours"
        ]
      },
      {
        "name": "History",
        "chapters": [
          "Bricks, Beads and Bones: The Harappan Civilisation",
          "Kings, Farmers and Towns: Early States and Economies",
          "Kinship, Caste and Class: Early Societies",
          "Thinkers, Beliefs and Buildings: Cultural Developments",
          "Through the Eyes of Travellers: Perceptions of Society",
          "Bhakti-Sufi Traditions",
          "An Imperial Capital: Vijayanagara",
          "Peasants, Zamindars and the State",
          "Kings and Chronicles: The Mughal Courts",
          "Colonialism and the Countryside",
          "Rebels and the Raj: The Revolt of 1857 and its Representations",
          "Colonial Cities",
          "Mahatma Gandhi and the Nationalist Movement",
          "Understanding Partition",
          "Framing the Constitution"
        ]
      },
      {
        "name": "Political Science",
        "chapters": [
          "The Cold War Era",
          "The End of Bipolarity",
          "US Hegemony in World Politics",
          "Alternative Centres of Power",
          "Contemporary South Asia",
          "International Organisations",
          "Security in the Contemporary World",
          "Environment and Natural Resources",
          "Globalisation",
          "Era of One-Party Dominance",
          "Nation Building and Its Problems",
          "Politics of Planned Development",
          "India's External Relations",
          "Challenges to and Restoration of the Congress System",
          "Crisis of the Democratic Order",
          "Rise of Popular Movements",
          "Regional Aspirations",
          "Recent Developments in Indian Politics"
        ]
      },
      {
        "name": "Geography",
        "chapters": [
          "Human Geography: Nature and Scope",
          "The World Population: Distribution, Density and Growth",
          "Population Composition",
          "Human Development",
          "Primary Activities",
          "Secondary Activities",
          "Tertiary and Quaternary Activities",
          "Transport and Communication",
          "International Trade",
          "Human Settlements",
          "Population: Distribution, Density, Growth and Composition",
          "Migration: Types, Causes and Consequences",
          "Human Development",
          "Human Settlements",
          "Land Resources and Agriculture",
          "Water Resources",
          "Mineral and Energy Resources",
          "Manufacturing Industries",
          "Planning and Sustainable Development in Indian Context",
          "Transport and Communication",
          "International Trade",
          "Geographical Perspective on Selected Issues and Problems"
        ]
      },
      {
        "name": "English (Flamingo)",
        "chapters": [
          "The Last Lesson",
          "Lost Spring",
          "Deep Water",
          "The Rattrap",
          "Indigo",
          "Poets and Pancakes",
          "The Interview",
          "Going Places"
        ]
      },
      {
        "name": "Computer Science (Elective)",
        "chapters": [
          "Review of Python",
          "Exception Handling",
          "File Handling",
          "Stack",
          "Queue",
          "Searching and Sorting",
          "Understanding Data",
          "Pandas – I",
          "Pandas – II",
          "Data Visualisation",
          "Computer Networks",
          "Database Management",
          "SQL",
          "Boolean Algebra",
          "Communication and Network Technologies",
          "Security Aspects"
        ]
      }
    ]
  },
  "ICSE": {
    "1": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers 1–100",
          "Addition and Subtraction",
          "Shapes and Patterns",
          "Measurement",
          "Time and Calendar",
          "Money",
          "Data Handling – Pictographs"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension Passages",
          "Composition",
          "Grammar: Nouns and Pronouns",
          "Grammar: Verbs and Tenses",
          "Grammar: Adjectives and Adverbs",
          "Punctuation",
          "Vocabulary Building",
          "Oral Communication"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "Myself",
          "My Family",
          "My School",
          "Food",
          "Clothing",
          "Shelter",
          "Plants and Animals",
          "Earth and Sky",
          "Transport and Communication"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "वर्णमाला",
          "मात्राएँ",
          "शब्द और वाक्य",
          "मेरा परिवार",
          "पशु-पक्षी",
          "मेरा विद्यालय",
          "खेल",
          "त्योहार",
          "प्रकृति"
        ]
      }
    ],
    "2": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers to 1000",
          "Addition",
          "Subtraction",
          "Multiplication: Tables 2–5",
          "Division Basics",
          "Fractions (Half, Quarter)",
          "Geometry: 2D Shapes",
          "Measurement: Length and Mass",
          "Measurement: Capacity",
          "Time",
          "Money",
          "Pictographs"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension",
          "Story Writing",
          "Description and Narration",
          "Nouns: Types and Number",
          "Pronouns",
          "Verbs: Present and Past",
          "Adjectives",
          "Prepositions and Conjunctions",
          "Sentences: Types",
          "Punctuation and Spelling"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "Living and Non-Living Things",
          "Plants Around Us",
          "Animals Around Us",
          "Our Body",
          "Food and Nutrition",
          "Cleanliness and Health",
          "Water",
          "Air",
          "Seasons and Weather",
          "Our Earth"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "शब्द-भंडार",
          "मेरा घर",
          "मेरे मित्र",
          "बाज़ार",
          "यातायात",
          "पर्यावरण",
          "कहानी-लेखन",
          "पत्र-लेखन",
          "कविता-पाठ"
        ]
      }
    ],
    "3": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers to 10000",
          "Addition and Subtraction",
          "Multiplication",
          "Division",
          "Fractions",
          "Geometry: Angles and Lines",
          "Perimeter and Area",
          "Measurement: Length, Mass, Capacity",
          "Time",
          "Money",
          "Data Handling"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension and Reading",
          "Formal and Informal Letters",
          "Story and Picture Composition",
          "Nouns and Pronouns – Advanced",
          "Tenses: Simple and Continuous",
          "Adjectives and Degrees of Comparison",
          "Adverbs",
          "Prepositions",
          "Active and Passive Voice Basics",
          "Direct and Indirect Speech Basics"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Plants: Parts and Functions",
          "Animals: Classification",
          "The Human Body: Bones and Muscles",
          "Food and Digestion",
          "Matter and Materials",
          "Light and Shadow",
          "Sound",
          "Magnets",
          "Water Cycle",
          "Our Environment"
        ]
      },
      {
        "name": "Social Studies",
        "chapters": [
          "Maps and Globes",
          "Weather and Climate",
          "Landforms and Water Bodies",
          "Natural Resources",
          "Agriculture",
          "Transport",
          "Communication",
          "Our Country India",
          "Our Constitution",
          "Local Self Government"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "गद्य-पाठ",
          "पद्य-पाठ",
          "व्याकरण: संज्ञा, सर्वनाम",
          "व्याकरण: विशेषण, क्रिया",
          "मात्राएँ और वर्तनी",
          "पत्र-लेखन",
          "निबंध-लेखन",
          "अनुच्छेद-लेखन",
          "समझ-बूझ"
        ]
      }
    ],
    "4": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers to 100000",
          "Operations on Large Numbers",
          "Factors and Multiples",
          "Fractions: Operations",
          "Decimals: Introduction",
          "Geometry: Triangles and Quadrilaterals",
          "Area and Perimeter",
          "Volume: Introduction",
          "Measurement: Units and Conversion",
          "Time: 24-Hour Clock",
          "Money: Bills and Transactions",
          "Data Handling: Bar Graphs"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension: Unseen Passages",
          "Essay and Composition",
          "Letter Writing: Formal",
          "Grammar: All Tenses",
          "Grammar: Clauses",
          "Vocabulary: Synonyms and Antonyms",
          "Figures of Speech: Simile and Metaphor",
          "Reported Speech",
          "Question Tags",
          "Editing and Proofreading"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Adaptations in Plants",
          "Adaptations in Animals",
          "The Skeletal and Muscular System",
          "The Digestive System",
          "Matter: Solid, Liquid, Gas",
          "Mixtures and Solutions",
          "Sources of Energy",
          "Electricity: Circuits",
          "The Solar System",
          "Conservation of Environment"
        ]
      },
      {
        "name": "Social Studies",
        "chapters": [
          "Physical and Political Maps of India",
          "The Northern Mountains",
          "The Northern Plains",
          "The Coastal Plains and Islands",
          "Climate of India",
          "Natural Vegetation and Wildlife of India",
          "Agriculture in India",
          "Industries in India",
          "Means of Transport in India",
          "Indian History: Ancient Civilisations"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "गद्य-संकलन",
          "पद्य-संकलन",
          "व्याकरण: काल",
          "व्याकरण: वाक्य",
          "मुहावरे और लोकोक्तियाँ",
          "पत्र-लेखन",
          "निबंध-लेखन",
          "संवाद-लेखन",
          "अपठित गद्यांश"
        ]
      }
    ],
    "5": [
      {
        "name": "Mathematics",
        "chapters": [
          "Large Numbers and Operations",
          "Factors, Multiples and Prime Numbers",
          "Fractions: All Operations",
          "Decimals: All Operations",
          "Percentages: Introduction",
          "Geometry: Properties of Shapes",
          "Area, Perimeter and Volume",
          "Ratio and Proportion: Introduction",
          "Speed, Distance and Time: Introduction",
          "Profit and Loss: Introduction",
          "Data Handling: Mean, Mode, Median"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension: Multiple Texts",
          "Creative Writing: Stories and Descriptions",
          "Formal Letter Writing",
          "Grammar: All Parts of Speech",
          "Sentences: Simple, Compound, Complex",
          "Active and Passive Voice",
          "Direct and Indirect Speech",
          "Idioms and Phrases",
          "Précis Writing: Introduction",
          "Editing: Grammar and Punctuation"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Food Production: Plants and Animals",
          "The Circulatory System",
          "The Nervous System",
          "Matter and its Properties",
          "Physical and Chemical Changes",
          "Force and Motion",
          "Simple Machines",
          "Light: Reflection and Refraction",
          "Sound: Properties",
          "The Universe and Space Exploration",
          "Environmental Conservation"
        ]
      },
      {
        "name": "Social Studies",
        "chapters": [
          "Globe and Maps",
          "Continents and Oceans",
          "Climate and Natural Vegetation",
          "Natural Disasters",
          "The Indus Valley Civilisation",
          "The Vedic Age",
          "Mauryan Empire",
          "The Guptas and Their Age",
          "Medieval India: Delhi Sultanate",
          "Mughal Empire",
          "India's Independence Movement: Overview"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "गद्य-पाठ (कहानी और निबंध)",
          "पद्य-पाठ (कविता)",
          "व्याकरण: संधि और समास",
          "व्याकरण: अलंकार",
          "पत्र और आवेदन-लेखन",
          "निबंध-लेखन",
          "अपठित गद्यांश एवं पद्यांश",
          "मुहावरे, लोकोक्तियाँ एवं मुहावरे"
        ]
      }
    ],
    "6": [
      {
        "name": "Mathematics",
        "chapters": [
          "Natural Numbers and Whole Numbers",
          "Integers",
          "Fractions",
          "Decimals and Percentages",
          "Ratio and Proportion",
          "Algebraic Expressions",
          "Simple Linear Equations",
          "Lines and Angles",
          "Triangles: Properties",
          "Quadrilaterals",
          "Circle: Introduction",
          "Perimeter, Area and Volume",
          "Data Handling: Frequency Distribution",
          "Speed, Time and Distance"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Matter",
          "Physical Quantities and Measurement",
          "Force and Pressure",
          "Simple Machines",
          "Light: Reflection",
          "Sound: Properties and Propagation",
          "Heat: Temperature and Thermometry",
          "Electricity and Circuits"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Introduction to Chemistry",
          "Elements, Compounds and Mixtures",
          "Separation of Mixtures",
          "Atoms and Molecules",
          "Acids, Bases and Salts: Introduction",
          "Air and Atmosphere",
          "Water"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Cell: The Basic Unit of Life",
          "Tissues: Plant and Animal",
          "Nutrition in Plants",
          "Nutrition in Animals",
          "Transportation in Plants and Animals",
          "Respiration in Plants and Animals",
          "Excretion",
          "Reproduction: Introduction",
          "Sense Organs"
        ]
      },
      {
        "name": "History and Civics",
        "chapters": [
          "Introduction: History and Its Sources",
          "The Harappan (Indus Valley) Civilisation",
          "The Vedic Civilisation",
          "Jainism and Buddhism",
          "The Mauryan Empire",
          "The Gupta Period",
          "The Constitution of India: Preamble",
          "Our Fundamental Rights",
          "The Union Government: Parliament",
          "The State Government"
        ]
      },
      {
        "name": "Geography",
        "chapters": [
          "Earth as a Planet",
          "Globe",
          "Latitudes and Longitudes",
          "Rotation and Revolution of the Earth",
          "Structure of the Earth",
          "Landforms",
          "Rocks",
          "Volcanoes",
          "Earthquakes",
          "Hydrosphere",
          "Atmosphere",
          "Weather and Climate",
          "Natural Regions of the World: Introduction"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension",
          "Essay Writing",
          "Story Writing",
          "Letter Writing",
          "Grammar: Tenses (All)",
          "Grammar: Voice",
          "Grammar: Narration",
          "Grammar: Transformation of Sentences",
          "Grammar: Prepositions and Conjunctions",
          "Punctuation and Spelling",
          "Notice Writing",
          "Dialogue Writing"
        ]
      },
      {
        "name": "English Literature",
        "chapters": [
          "Poetry: Selected Poems",
          "Prose: Short Stories",
          "Drama: Scenes and Acts",
          "Literary Devices: Simile, Metaphor, Alliteration",
          "Character Analysis",
          "Theme and Message",
          "Comprehension of Unseen Passages"
        ]
      },
      {
        "name": "Hindi",
        "chapters": [
          "गद्य-पाठ",
          "पद्य-पाठ",
          "व्याकरण: विराम-चिह्न",
          "व्याकरण: अनेकार्थी शब्द",
          "पत्र-लेखन",
          "निबंध-लेखन",
          "अपठित गद्यांश",
          "संवाद-लेखन"
        ]
      }
    ],
    "7": [
      {
        "name": "Mathematics",
        "chapters": [
          "Integers: All Operations",
          "Rational Numbers",
          "Fractions, Decimals, Percentages",
          "Ratio, Proportion and Unitary Method",
          "Profit, Loss and Discount",
          "Simple Interest",
          "Algebraic Expressions: Addition and Subtraction",
          "Simple Equations",
          "Properties of Triangles",
          "Congruency of Triangles",
          "Circle: Chords and Arcs",
          "Area of Triangles and Quadrilaterals",
          "Volume and Surface Area",
          "Data Handling: Mean, Mode, Median",
          "Symmetry and Reflection"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Physical Quantities and Measurement",
          "Motion",
          "Speed and Velocity",
          "Energy",
          "Light: Reflection and Refraction",
          "Sounds: Propagation and Properties",
          "Electricity: Current and Circuits",
          "Magnetism"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Matter and Its Composition",
          "Physical and Chemical Changes",
          "Elements, Compounds and Mixtures",
          "Atomic Structure",
          "Language of Chemistry: Symbols and Formulae",
          "Acids, Bases and Salts",
          "Metals and Non-Metals",
          "Air and Atmosphere"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Plant and Animal Tissues",
          "Absorption by Roots",
          "Photosynthesis",
          "The Flower",
          "Pollination and Fertilisation",
          "Seed Dispersal",
          "The Digestive System",
          "The Circulatory System",
          "The Excretory System",
          "The Nervous System: Introduction",
          "Reproduction in Plants"
        ]
      },
      {
        "name": "History and Civics",
        "chapters": [
          "Medieval Period: Overview",
          "Delhi Sultanate",
          "The Mughal Empire",
          "The Bhakti Movement",
          "The Advent of Europeans",
          "British Conquest of India",
          "Structure of the Indian Government",
          "The Judiciary",
          "Local Self Government",
          "The United Nations"
        ]
      },
      {
        "name": "Geography",
        "chapters": [
          "The Lithosphere",
          "Landforms and their Evolution",
          "The Atmosphere and its Composition",
          "Insolation",
          "Atmospheric Pressure and Winds",
          "Humidity and Precipitation",
          "Types of Climate",
          "The Hydrosphere",
          "Ocean Currents",
          "Natural Regions of the World"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension: Prose and Poetry",
          "Essay: Discursive and Descriptive",
          "Letter: Personal and Formal",
          "Grammar: Conditionals",
          "Grammar: Reported Speech – Advanced",
          "Grammar: Modals",
          "Idioms and Phrases",
          "Précis Writing",
          "Report Writing: Introduction",
          "Advertisement Writing"
        ]
      },
      {
        "name": "English Literature",
        "chapters": [
          "Poetry: Appreciation and Analysis",
          "Prose: Comprehension and Analysis",
          "Drama: Character and Theme",
          "Novel/Long Reader: Chapters",
          "Literary Devices: Irony, Symbolism",
          "Essay on Themes"
        ]
      },
      {
        "name": "Computer Applications",
        "chapters": [
          "Number Systems",
          "HTML Basics",
          "HTML: Tables and Forms",
          "Introduction to Java",
          "Variables and Data Types in Java",
          "Operators in Java",
          "Control Structures: if-else",
          "Control Structures: Loops",
          "Introduction to OOP"
        ]
      }
    ],
    "8": [
      {
        "name": "Mathematics",
        "chapters": [
          "Rational Numbers: Properties",
          "Exponents",
          "Squares and Square Roots",
          "Cubes and Cube Roots",
          "Playing with Numbers",
          "Sets: Introduction",
          "Percentage and its Applications",
          "Profit, Loss, Discount, and Tax",
          "Compound Interest",
          "Direct and Inverse Proportion",
          "Time and Work",
          "Algebraic Identities",
          "Factorisation",
          "Linear Equations in One Variable",
          "Understanding Quadrilaterals",
          "Area of a Trapezium and Polygon",
          "Surface Area and Volume",
          "Data Handling: Pie Charts and Bar Graphs",
          "Probability: Introduction"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Matter: Kinetic Theory",
          "Physical Quantities and Their Measurement",
          "Force and Pressure",
          "Turning Effect of Forces",
          "Work, Power and Energy",
          "Light: Laws of Reflection",
          "Sound: Vibrations and Waves",
          "Electrical Circuits and Effects",
          "Heat Transfer"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Language of Chemistry",
          "Chemical Changes and Reactions",
          "Water",
          "Hydrogen",
          "Oxygen",
          "Carbon",
          "Sulphur",
          "Nitrogen",
          "Atmosphere and its Pollution"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Cell: Structure and Functions",
          "Plant Nutrition",
          "Respiration in Plants",
          "Transportation in Plants",
          "Excretion in Plants",
          "Reproduction in Plants",
          "Ecosystem",
          "Endocrine System",
          "The Nervous System",
          "The Sense Organs",
          "Adolescence"
        ]
      },
      {
        "name": "History and Civics",
        "chapters": [
          "The First War of Independence – 1857",
          "The Rise of Indian Nationalism",
          "The Indian National Congress",
          "Mass Movements in India",
          "Independence and Partition of India",
          "The Indian Constitution",
          "Fundamental Rights and Duties",
          "The Union Legislature",
          "The Executive",
          "The Judiciary"
        ]
      },
      {
        "name": "Geography",
        "chapters": [
          "Resources",
          "Land Resources",
          "Minerals and Rocks",
          "Agriculture",
          "Industries",
          "Transport, Communication and Trade",
          "Human Settlements",
          "Natural Calamities",
          "Pollution",
          "Conservation of Resources"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension: Unseen and Seen",
          "Essay: Argumentative",
          "Formal Letters and Applications",
          "Report Writing",
          "Grammar: Revision of All Structures",
          "Grammar: Conditionals – All Types",
          "Précis Writing",
          "Speech Writing",
          "Notice and Circular",
          "Email Writing"
        ]
      },
      {
        "name": "Computer Applications",
        "chapters": [
          "Boolean Algebra",
          "Basics of Java",
          "OOP: Classes and Objects",
          "OOP: Inheritance",
          "Strings in Java",
          "Arrays in Java",
          "Math Class Functions",
          "Programs: Pattern-based",
          "Programs: Mathematical",
          "Introduction to Algorithms"
        ]
      }
    ],
    "9": [
      {
        "name": "Mathematics",
        "chapters": [
          "Pure Arithmetic: Rational and Irrational Numbers",
          "Commercial Mathematics: Compound Interest",
          "Algebra: Expansions",
          "Algebra: Factorisation",
          "Algebra: Simultaneous Equations",
          "Indices (Exponents)",
          "Logarithms",
          "Geometry: Triangles",
          "Geometry: Mid-Point and Intercept Theorems",
          "Geometry: Pythagoras Theorem",
          "Geometry: Rectilinear Figures",
          "Geometry: Circle",
          "Geometry: Constructions",
          "Trigonometry: Introduction",
          "Statistics: Mean, Median, Mode",
          "Mensuration: 2D and 3D Shapes"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Measurements and Experimentation",
          "Motion in One Dimension",
          "Laws of Motion",
          "Pressure in Fluids and Atmospheric Pressure",
          "Upthrust in Fluids: Archimedes' Principle",
          "Heat and Energy",
          "Reflection of Light",
          "Refraction of Light",
          "Sound",
          "Electricity and Ohm's Law"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "The Language of Chemistry",
          "Chemical Changes and Reactions",
          "Water",
          "Atomic Structure",
          "The Periodic Table",
          "Study of Gas Laws",
          "Acids, Bases and Salts",
          "Analytical Chemistry",
          "Mole Concept and Stoichiometry"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Basic Biology: Cells",
          "Cell Cycle and Division",
          "Tissues: Plant",
          "Tissues: Animal",
          "The Flower",
          "Pollination and Fertilisation",
          "Seeds: Structure and Germination",
          "Respiration in Plants",
          "Five Kingdom Classification",
          "Economic Importance of Bacteria and Fungi"
        ]
      },
      {
        "name": "History and Civics",
        "chapters": [
          "The Harappan Civilisation",
          "The Vedic Period",
          "Jainism and Buddhism",
          "The Mauryas",
          "The Age of the Guptas",
          "Medieval India: Delhi Sultanate",
          "The Mughals",
          "British Advent in India",
          "The First War of Independence",
          "Mass Nationalism in India",
          "United Nations: Structure and Role",
          "Non-Aligned Movement",
          "India and the Commonwealth"
        ]
      },
      {
        "name": "Geography (India – Land)",
        "chapters": [
          "India: Location, Extent and Physical Features",
          "India: Structure and Physiography",
          "India: Drainage System",
          "India: Climate",
          "India: Natural Vegetation",
          "India: Water Resources",
          "India: Mineral and Energy Resources",
          "India: Agriculture",
          "India: Industry",
          "India: Transport and Communication",
          "India: Waste Management"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension (Unseen)",
          "Continuous Writing: Narrative and Descriptive",
          "Directed Writing: Letter, Report, Speech",
          "Grammar: Tenses – Revision",
          "Grammar: Non-Finites – Gerund, Infinitive, Participle",
          "Grammar: Clauses",
          "Grammar: Conditionals",
          "Grammar: Voice",
          "Grammar: Narration",
          "Vocabulary: Idioms, Phrases, Word Formation"
        ]
      },
      {
        "name": "English Literature",
        "chapters": [
          "Selected Poetry",
          "Selected Prose",
          "Drama or Novel: Act/Chapter Comprehension",
          "Character Sketches",
          "Themes and Messages",
          "Appreciation Essays",
          "Diary Entry / Letter from a Character"
        ]
      },
      {
        "name": "Computer Applications",
        "chapters": [
          "Introduction to OOP in Java",
          "Class, Object and Methods",
          "Constructors",
          "Library Classes: Math, String",
          "Conditional Statements",
          "Iteration Statements",
          "Arrays: Single and Double Dimensional",
          "String Manipulation",
          "Recursion",
          "Algorithms and Flowcharts"
        ]
      }
    ],
    "10": [
      {
        "name": "Mathematics",
        "chapters": [
          "Commercial Mathematics: GST and Banking",
          "Algebra: Linear Inequations",
          "Algebra: Quadratic Equations",
          "Ratio and Proportion",
          "Factorisation of Polynomials",
          "Matrices",
          "Arithmetic Progression",
          "Co-ordinate Geometry: Reflection",
          "Co-ordinate Geometry: Section and Midpoint Formulae",
          "Co-ordinate Geometry: Equation of a Line",
          "Geometry: Similarity",
          "Geometry: Circles and Tangents",
          "Geometry: Angle Properties",
          "Geometry: Cyclic Properties",
          "Geometry: Constructions",
          "Mensuration: Cylinder, Cone and Sphere",
          "Trigonometry: Heights and Distances",
          "Statistics: Frequency Distribution, Histograms",
          "Probability"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Force, Work, Power and Energy",
          "Simple Machines",
          "Refraction of Light at Plane Surfaces",
          "Refraction through a Lens",
          "Spectrum",
          "Sound",
          "Electricity",
          "Household Circuits",
          "Magnetic Effect of Current",
          "Electromagnetic Induction",
          "Calorimetry",
          "Radioactivity",
          "The Universe"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Periodic Table",
          "Chemical Bonding",
          "Acids, Bases and Salts",
          "Analytical Chemistry",
          "Mole Concept and Stoichiometry",
          "Electrolysis",
          "Metallurgy",
          "Study of Compounds: Hydrogen Chloride",
          "Study of Compounds: Ammonia",
          "Study of Compounds: Nitric Acid",
          "Study of Compounds: Sulphuric Acid",
          "Organic Chemistry"
        ]
      },
      {
        "name": "Biology",
        "chapters": [
          "Cell Division: Mitosis and Meiosis",
          "Structure of Chromosomes, DNA and Genes",
          "Absorption by Roots",
          "Transpiration",
          "Photosynthesis",
          "The Circulatory System",
          "The Excretory System",
          "The Nervous System and Sense Organs",
          "The Endocrine System",
          "Reproduction in Humans",
          "Population",
          "Pollution",
          "Human Evolution"
        ]
      },
      {
        "name": "History and Civics",
        "chapters": [
          "Rise of Nationalism in Europe",
          "Nationalism in India: Gandhian Phase",
          "Independence and Partition of India",
          "United Nations",
          "Non-Aligned Movement",
          "India's Foreign Policy",
          "Human Rights",
          "Disarmament",
          "Common Wealth",
          "The Basic Framework of the Indian Constitution",
          "The Union Legislature",
          "The Union Executive",
          "The Judiciary",
          "Local Self Government in India"
        ]
      },
      {
        "name": "Geography (India – People and Economy)",
        "chapters": [
          "Population",
          "Migration",
          "Human Development",
          "Human Settlements",
          "Land Resources and Agriculture",
          "Water Resources",
          "Mineral and Energy Resources",
          "Manufacturing Industries",
          "Planning and Sustainable Development",
          "Transport and Communication",
          "International Trade",
          "Geographical Perspective on Issues and Problems"
        ]
      },
      {
        "name": "English Language",
        "chapters": [
          "Comprehension: Unseen Passages",
          "Letter to the Editor",
          "Speech Writing",
          "Report Writing",
          "Grammar: Error Correction",
          "Grammar: Sentence Transformation",
          "Grammar: Fill in the Blanks",
          "Vocabulary: Synonyms, Antonyms, Homophones",
          "Formal and Informal Register",
          "Précis Writing"
        ]
      },
      {
        "name": "English Literature",
        "chapters": [
          "Poetry: Prescribed Poems",
          "Short Stories: Prescribed Texts",
          "Drama: Acts and Scenes",
          "Novel: Chapters and Themes",
          "Character Analysis",
          "Theme and Message",
          "Critical Appreciation"
        ]
      },
      {
        "name": "Computer Applications",
        "chapters": [
          "Class and Objects: Review",
          "Inheritance in Java",
          "Polymorphism and Interfaces",
          "Exception Handling",
          "File Handling Basics",
          "Arrays: Multi-dimensional",
          "String Methods",
          "Algorithms: Sorting (Bubble, Selection, Insertion)",
          "Algorithms: Searching (Linear, Binary)",
          "Introduction to Data Structures: Stack and Queue"
        ]
      }
    ],
    "11": [
      {
        "name": "Mathematics (ISC)",
        "chapters": [
          "Sets and Functions",
          "Complex Numbers",
          "Quadratic Equations",
          "Sequence and Series",
          "Permutations and Combinations",
          "Mathematical Induction",
          "Binomial Theorem",
          "Straight Lines",
          "Circles",
          "Conic Sections",
          "Trigonometry",
          "Inverse Trigonometry",
          "Limits and Derivatives",
          "Mathematical Reasoning",
          "Statistics",
          "Probability",
          "Matrices and Determinants: Introduction"
        ]
      },
      {
        "name": "Physics (ISC)",
        "chapters": [
          "Physical World and Measurement",
          "Kinematics",
          "Laws of Motion",
          "Work, Energy and Power",
          "Motion of System of Particles and Rigid Body",
          "Gravitation",
          "Properties of Bulk Matter",
          "Thermodynamics",
          "Kinetic Theory of Gases",
          "Oscillations",
          "Waves"
        ]
      },
      {
        "name": "Chemistry (ISC)",
        "chapters": [
          "Some Basic Concepts of Chemistry",
          "Structure of Atom",
          "Classification of Elements: Periodicity",
          "Chemical Bonding and Molecular Structure",
          "States of Matter",
          "Thermodynamics",
          "Equilibrium",
          "Redox Reactions",
          "Hydrogen",
          "s-Block and p-Block Elements",
          "Hydrocarbons",
          "Environmental Chemistry"
        ]
      },
      {
        "name": "Biology (ISC)",
        "chapters": [
          "The Living World",
          "Biological Classification",
          "Cell: Structure and Function",
          "Biomolecules",
          "Cell Cycle and Cell Division",
          "Morphology of Flowering Plants",
          "Anatomy of Flowering Plants",
          "Structural Organisation in Animals",
          "Plant Physiology: Transport",
          "Plant Physiology: Photosynthesis",
          "Plant Physiology: Respiration",
          "Plant Physiology: Growth",
          "Human Physiology: Digestion and Absorption",
          "Human Physiology: Breathing and Exchange of Gases",
          "Human Physiology: Body Fluids and Circulation",
          "Human Physiology: Excretory Products and Elimination",
          "Human Physiology: Locomotion and Movement",
          "Human Physiology: Neural Control and Coordination",
          "Human Physiology: Chemical Coordination"
        ]
      },
      {
        "name": "Accounts (ISC)",
        "chapters": [
          "Introduction to Accounting",
          "Theory Base of Accounting",
          "Recording of Transactions",
          "Trial Balance and Rectification of Errors",
          "Depreciation",
          "Final Accounts of Sole Proprietorship",
          "Accounts from Incomplete Records",
          "Accounting for Partnership Firms",
          "Computerised Accounting"
        ]
      },
      {
        "name": "Commerce (ISC)",
        "chapters": [
          "Nature and Scope of Business",
          "Forms of Business Organisations",
          "Joint Stock Company",
          "Business Finance",
          "Marketing Management",
          "Consumer Protection",
          "Banking",
          "Insurance",
          "Export and Import Trade",
          "Communication in Business"
        ]
      },
      {
        "name": "Economics (ISC)",
        "chapters": [
          "Introduction to Economics",
          "Consumer Behaviour",
          "Production Function and Law of Returns",
          "Cost and Revenue",
          "Price Determination: Perfect Competition",
          "Price Determination: Monopoly",
          "Introduction to Macroeconomics",
          "National Income",
          "Money and Banking",
          "Fiscal Policy"
        ]
      },
      {
        "name": "English (ISC)",
        "chapters": [
          "Prose: Prescribed Texts",
          "Poetry: Prescribed Poems",
          "Drama: Prescribed Play",
          "Short Stories",
          "Essay Writing",
          "Grammar and Usage",
          "Comprehension of Unseen Passages"
        ]
      },
      {
        "name": "Computer Science (ISC)",
        "chapters": [
          "Computer Hardware Components",
          "Fundamentals of Boolean Algebra",
          "Algorithms and Flowcharts",
          "Introduction to Java",
          "OOP: Classes and Objects",
          "Inheritance",
          "Polymorphism",
          "Interfaces and Abstract Classes",
          "Exception Handling",
          "File Handling",
          "Data Structures: Arrays",
          "Data Structures: Linked List",
          "Data Structures: Stack",
          "Data Structures: Queue",
          "Sorting Algorithms",
          "Searching Algorithms",
          "Introduction to Networking"
        ]
      }
    ],
    "12": [
      {
        "name": "Mathematics (ISC)",
        "chapters": [
          "Relations and Functions",
          "Inverse Trigonometric Functions",
          "Algebra of Matrices",
          "Determinants",
          "Continuity and Differentiability",
          "Differentiation",
          "Applications of Derivatives",
          "Integrals",
          "Applications of Integrals",
          "Differential Equations",
          "Vectors",
          "Three Dimensional Geometry",
          "Linear Programming",
          "Probability"
        ]
      },
      {
        "name": "Physics (ISC)",
        "chapters": [
          "Electrostatics",
          "Current Electricity",
          "Magnetic Effects of Current",
          "Magnetism",
          "Electromagnetic Induction",
          "Alternating Currents",
          "Electromagnetic Waves",
          "Ray Optics",
          "Wave Optics",
          "Dual Nature of Radiation and Matter",
          "Atoms and Nuclei",
          "Electronic Devices",
          "Communication Systems"
        ]
      },
      {
        "name": "Chemistry (ISC)",
        "chapters": [
          "Solid State",
          "Solutions",
          "Electrochemistry",
          "Chemical Kinetics",
          "Surface Chemistry",
          "Isolation of Elements",
          "p-Block Elements",
          "d- and f-Block Elements",
          "Coordination Compounds",
          "Haloalkanes and Haloarenes",
          "Alcohols, Phenols and Ethers",
          "Aldehydes, Ketones and Carboxylic Acids",
          "Organic Nitrogen Compounds",
          "Biomolecules and Polymers",
          "Chemistry in Everyday Life"
        ]
      },
      {
        "name": "Biology (ISC)",
        "chapters": [
          "Reproduction in Organisms",
          "Sexual Reproduction in Flowering Plants",
          "Human Reproduction",
          "Reproductive Health",
          "Principles of Inheritance and Variation",
          "Molecular Basis of Inheritance",
          "Evolution",
          "Human Health and Disease",
          "Strategies for Food Production",
          "Microbes in Human Welfare",
          "Biotechnology: Principles",
          "Biotechnology: Applications",
          "Organisms and Populations",
          "Ecosystem",
          "Biodiversity and Conservation",
          "Environmental Issues"
        ]
      },
      {
        "name": "Accounts (ISC)",
        "chapters": [
          "Partnership Accounts: Goodwill",
          "Admission of a Partner",
          "Retirement and Death of a Partner",
          "Dissolution of Partnership",
          "Issue of Shares",
          "Issue of Debentures",
          "Financial Statements of a Company",
          "Ratio Analysis",
          "Cash Flow Statement"
        ]
      },
      {
        "name": "Commerce (ISC)",
        "chapters": [
          "Entrepreneurship Development",
          "Business Ethics and Corporate Social Responsibility",
          "E-Commerce",
          "Warehousing",
          "Channels of Distribution",
          "Advertising",
          "Sales Promotion",
          "Public Relations",
          "International Marketing",
          "Trade Policies and Agreements"
        ]
      },
      {
        "name": "Economics (ISC)",
        "chapters": [
          "Theory of Income and Employment",
          "Money Supply and Inflation",
          "Banking System",
          "Government Budget",
          "Balance of Payments",
          "Indian Economy: Overview",
          "Agriculture in India",
          "Industries in India",
          "Infrastructure and Economic Development",
          "Globalisation and the Indian Economy",
          "Indian Economy: Recent Challenges"
        ]
      },
      {
        "name": "English (ISC)",
        "chapters": [
          "Prescribed Prose Texts",
          "Prescribed Poetry",
          "Prescribed Drama",
          "Essay Writing",
          "Directed Writing: Article, Speech, Report",
          "Grammar Revision",
          "Comprehension: Unseen"
        ]
      },
      {
        "name": "Computer Science (ISC)",
        "chapters": [
          "Review of OOP",
          "Advanced OOP: Abstract Classes and Interfaces",
          "String Handling",
          "Array-Based Programs",
          "Recursion",
          "Data Structures: Linked List Implementation",
          "Data Structures: Stack and Queue Implementation",
          "Sorting: Quick Sort, Merge Sort",
          "Searching and Complexity Analysis",
          "Database Management Systems: Introduction",
          "SQL Queries",
          "Networking: Protocols",
          "HTML and Web Technologies",
          "Boolean Algebra: Advanced",
          "Project Work"
        ]
      }
    ]
  },
  "TN_SAMACHEER": {
    "1": [
      {
        "name": "Mathematics",
        "chapters": [
          "Shapes",
          "Numbers (1–9)",
          "Addition",
          "Subtraction",
          "Numbers (10–20)",
          "Numbers (21–100)",
          "Measurements",
          "Money",
          "Time",
          "Data Handling"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "What's your name?",
          "My Family",
          "My Body",
          "Animals and Birds",
          "My School",
          "Fruits and Vegetables",
          "Colours and Shapes",
          "Transport",
          "Seasons",
          "Festivals"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "வாழ்த்து",
          "என் உடல்",
          "என் குடும்பம்",
          "என் பள்ளி",
          "விலங்குகளும் பறவைகளும்",
          "பழங்களும் காய்கறிகளும்",
          "வீட்டுப் பயன்பாட்டுப் பொருள்கள்",
          "போக்குவரத்து",
          "விழாக்கள்",
          "இயற்கை"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "Me and My Family",
          "Plants",
          "Animals",
          "Food",
          "Shelter",
          "Water",
          "Air",
          "Transport",
          "Festivals",
          "Earth and Sky"
        ]
      }
    ],
    "2": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers (1–100)",
          "Addition",
          "Subtraction",
          "Shapes and Space",
          "Measurements",
          "Time",
          "Money",
          "Data Handling"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "My Neighbourhood",
          "At the Market",
          "Animals and their Babies",
          "The Seasons",
          "Food We Eat",
          "Water",
          "My Country",
          "Festivals",
          "Transport and Communication",
          "Taking Care of our Earth"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "உரிமை",
          "விளையாட்டு",
          "பாடும் நிலா",
          "விலங்குகள்",
          "வீரம்",
          "கடல்",
          "திருவிழா",
          "அன்னை",
          "பூக்கள்",
          "நீர்"
        ]
      },
      {
        "name": "Environmental Studies",
        "chapters": [
          "Family",
          "Pets",
          "Different Communities",
          "Seasons and Weather",
          "Healthy Habits",
          "Water and Air",
          "Roads and Safety",
          "Our Country"
        ]
      }
    ],
    "3": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers",
          "Addition",
          "Subtraction",
          "Multiplication",
          "Division",
          "Fractions: Introduction",
          "Measurements",
          "Time and Calendar",
          "Geometry: Shapes",
          "Data Handling"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Science Every Day",
          "Let's Go Green",
          "Helping Hands",
          "Feeling Fit",
          "True Friendship",
          "Our Neighbourhood",
          "Birds",
          "A Brave Girl",
          "India",
          "Let's Share and Care"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "கற்றுக்கொள்வோம்",
          "சுற்றுப்புறம்",
          "விலங்கின உலகம்",
          "தாய்நாடு",
          "நட்பு",
          "உடல் நலம்",
          "கடல் வாழ் உயிரினங்கள்",
          "பண்டிகை",
          "நீர் வாழ் உயிரினங்கள்",
          "கவிதை"
        ]
      },
      {
        "name": "Science (EVS)",
        "chapters": [
          "Plants",
          "Animals",
          "Our Body",
          "Food",
          "Matter",
          "Our Universe",
          "Weather and Climate",
          "Soil and Water",
          "Health and Hygiene",
          "Safety Rules"
        ]
      },
      {
        "name": "Social Science (EVS)",
        "chapters": [
          "Our Earth",
          "Map Reading",
          "Our Family and Community",
          "Transport",
          "Communication",
          "Our Country: Landforms",
          "Water Bodies of India",
          "Festivals of India",
          "Occupations"
        ]
      }
    ],
    "4": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers",
          "Fractions",
          "Multiplication",
          "Division",
          "Geometry",
          "Measurements",
          "Money",
          "Time",
          "Patterns",
          "Data Handling"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "The Eco-club",
          "Nature",
          "Books Are Our Friends",
          "The Enormous Turnip",
          "Our Great Architects",
          "Travel and Tourism",
          "A Letter to God",
          "Folk Tales of India",
          "Technology",
          "Save the Earth"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "அறிவின் சிறப்பு",
          "வாழும் உலகம்",
          "மழை",
          "சோலையும் வேட்டையும்",
          "கண்ணியமான வாழ்க்கை",
          "சமூக விழிப்புணர்வு",
          "பண்பாட்டு விழுமியங்கள்",
          "இயற்கை",
          "வீரம்",
          "நாட்டுப்பற்று"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Plants and their Classification",
          "Animals and their Classification",
          "Our Body",
          "Food and Digestion",
          "Matter and its Properties",
          "Forces",
          "Light and Shadow",
          "Sound",
          "Our Environment",
          "Good Habits for Health"
        ]
      },
      {
        "name": "Social Science",
        "chapters": [
          "Our Earth: Continents and Oceans",
          "Maps and Globe",
          "Seasons and Climate",
          "Water – Forms and Importance",
          "Landforms",
          "Physical Division of Tamil Nadu",
          "Early Civilisations",
          "Administrative Divisions",
          "Transport and Communication in TN"
        ]
      }
    ],
    "5": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers",
          "Fractions",
          "Geometry",
          "Measurements",
          "Area and Perimeter",
          "Ratio and Proportion",
          "Percentage",
          "Time and Speed",
          "Data Handling: Pictographs",
          "Patterns"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "I Wonder",
          "Bridge to Terabithia",
          "Helen Keller",
          "The Best Investment",
          "Brave Little Parrot",
          "The Adventures of Don Quixote",
          "A Discovery",
          "Gulliver's Travels",
          "Science and Technology",
          "How to be a Champion"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாடல்",
          "பண்டைக்காலம்",
          "காப்பியக் கதை",
          "நீதி நூல்",
          "இலக்கியம்",
          "விஞ்ஞானம்",
          "தமிழர் பண்பாடு",
          "சிறுகதை",
          "கடிதம்",
          "உரைநடை"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Plants",
          "Animals",
          "Human Body Systems",
          "Food and Nutrition",
          "Matter: States",
          "Metals and Non-Metals",
          "Energy: Sources and Types",
          "The Universe",
          "Natural Disasters",
          "Environmental Issues"
        ]
      },
      {
        "name": "Social Science",
        "chapters": [
          "Continent of Asia",
          "India: Location and Relief",
          "Climate and Natural Vegetation of India",
          "Irrigation and Water Management",
          "Indus Valley Civilisation",
          "The Vedic Age",
          "Jainism and Buddhism",
          "Mauryan Empire",
          "Administration in Tamil Nadu",
          "Rights and Duties of Citizens"
        ]
      }
    ],
    "6": [
      {
        "name": "Mathematics",
        "chapters": [
          "Numbers",
          "Introduction to Algebra",
          "Ratio and Proportion",
          "Geometry",
          "Practical Geometry",
          "Integers",
          "Fractions, Decimals and Percentages",
          "Statistics",
          "Measurements",
          "Symmetry"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Measurement",
          "Force and Motion",
          "Matter Around Us",
          "Atoms and Molecules",
          "The Cell",
          "Health and Hygiene",
          "Organisation of Life",
          "Light",
          "Electricity",
          "Plants: Reproduction"
        ]
      },
      {
        "name": "Social Science (History)",
        "chapters": [
          "Early Humans",
          "Indus Valley Civilisation",
          "Vedic Age",
          "Rise of Jainism and Buddhism",
          "Mauryan Empire",
          "Post-Mauryan Period",
          "Guptas",
          "Social Changes during Sangam Age",
          "Sangam Age Economy and Polity",
          "Early Tamil Kingdoms"
        ]
      },
      {
        "name": "Social Science (Geography)",
        "chapters": [
          "Earth and Solar System",
          "Lithosphere",
          "Atmosphere",
          "Hydrosphere",
          "Biosphere",
          "Map Reading",
          "India: Physical Features",
          "India: Climate",
          "India: Agriculture",
          "India: Industries"
        ]
      },
      {
        "name": "Social Science (Civics)",
        "chapters": [
          "Understanding Diversity",
          "Government at the Local Level",
          "Rural Administration",
          "Urban Administration",
          "Our Rights and Duties",
          "The Union Government"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Feel the Oneness",
          "Dare to Dream",
          "My Robot Does My Homework",
          "A Fishy Conversation",
          "The Midnight Visitor",
          "The Nose Jewel",
          "Memories of Childhood",
          "The World is Beautiful",
          "Literature",
          "Conservation of Nature"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு (கவிதை)",
          "இலக்கியம்",
          "குறுங்கதை",
          "வழக்காட்டு நாடகம்",
          "செய்தி – கட்டுரை",
          "மொழி",
          "தமிழ் இலக்கணம்: எழுத்து",
          "தமிழ் இலக்கணம்: சொல்",
          "செவ்வியல் தமிழ்",
          "நாட்டுப்பண்"
        ]
      }
    ],
    "7": [
      {
        "name": "Mathematics",
        "chapters": [
          "Number System",
          "Measurements",
          "Algebra",
          "Direct and Inverse Proportion",
          "Geometry",
          "Practical Geometry",
          "Perimeter and Area",
          "Rational Numbers",
          "Percentage and Simple Interest",
          "Statistics"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Measurement and Motion",
          "Force and Pressure",
          "Light",
          "Electric Charge and Electric Current",
          "Acids and Bases",
          "Nuclear Physics",
          "Heat and Temperature",
          "Sound",
          "Universe",
          "Animals: Nutrition and Reproduction",
          "Plant World",
          "Health and Hygiene"
        ]
      },
      {
        "name": "Social Science (History)",
        "chapters": [
          "Medieval World",
          "The Delhi Sultanate",
          "Vijayanagara Empire",
          "The Mughal Empire",
          "Social Transformation in Tamil Nadu",
          "The Bhakti Movement",
          "Advent of Europeans",
          "Impact of British Rule",
          "Revolt of 1857",
          "Social Reform Movements"
        ]
      },
      {
        "name": "Social Science (Geography)",
        "chapters": [
          "Atmosphere",
          "Hydrosphere",
          "Rocks and Soils",
          "Weather and Climate",
          "Forest Resources",
          "Mineral Resources",
          "Agriculture",
          "Industries",
          "Transport and Communication",
          "Man and Environment"
        ]
      },
      {
        "name": "Social Science (Civics & Economics)",
        "chapters": [
          "Constitution of India",
          "Fundamental Rights and Duties",
          "Legislature",
          "Executive",
          "Judiciary",
          "Democracy",
          "Public Services",
          "Economic Concepts",
          "Money and Banking",
          "Globalisation"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "A Prayer to the God of Rain",
          "Whales Weep Not!",
          "Discovery of India",
          "The Night the Ghost Got In",
          "An Astronaut's Guide",
          "The Secret Garden",
          "The Selfish Giant",
          "Wisdom from the Pages",
          "A Ballad of the Tempest",
          "Evelyn Glennie"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "குறுங்கதை",
          "நாடகம்",
          "இலக்கணம்: வேர்ச்சொல்",
          "இலக்கணம்: வினைமுற்று",
          "இலக்கணம்: பெயர்ச்சொல்",
          "செவ்வியல் இலக்கியம்",
          "கட்டுரை",
          "கடிதம்"
        ]
      }
    ],
    "8": [
      {
        "name": "Mathematics",
        "chapters": [
          "Rational Numbers",
          "Measurements",
          "Algebra",
          "Geometry",
          "Practical Geometry",
          "Statistics",
          "Direct and Inverse Proportion",
          "Life Mathematics",
          "Exponents and Powers",
          "Data Handling"
        ]
      },
      {
        "name": "Science",
        "chapters": [
          "Measurement",
          "Force and Pressure",
          "Light",
          "Stars and the Solar System",
          "Atomic Structure",
          "Fibre to Fabric to Life",
          "Heat",
          "Sound",
          "Electricity",
          "Conservation of Plants and Animals",
          "Microbes",
          "Reaching the Age of Adolescence",
          "Information Communication Technology"
        ]
      },
      {
        "name": "Social Science (History)",
        "chapters": [
          "Outbreak of World War I",
          "Rise of Fascism and Nazism",
          "World War II",
          "Post-War World",
          "Growth of Colonialism",
          "Resistance to Colonialism",
          "Socio-religious Reform Movements in India",
          "Freedom Struggle",
          "Roles of Tamil Nadu in the Freedom Struggle",
          "Independent India"
        ]
      },
      {
        "name": "Social Science (Geography)",
        "chapters": [
          "Resources",
          "Agriculture and Industries of the World",
          "Human Resources",
          "Physical Divisions of Tamil Nadu",
          "Natural Resources of Tamil Nadu",
          "Climate and Natural Vegetation of Tamil Nadu",
          "Population Distribution",
          "Industries of Tamil Nadu",
          "Transportation in Tamil Nadu"
        ]
      },
      {
        "name": "Social Science (Civics & Economics)",
        "chapters": [
          "India's Foreign Policy",
          "International Organizations",
          "United Nations",
          "India: Democracy and Elections",
          "Economic Development",
          "Public Finance",
          "Poverty and Unemployment",
          "Agriculture and Rural Economy"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Prose: Selected Texts",
          "Poetry: Selected Poems",
          "Drama",
          "Grammar: Tenses",
          "Grammar: Voice",
          "Grammar: Narration",
          "Grammar: Conditionals",
          "Writing: Essay, Letter, Report",
          "Comprehension",
          "Vocabulary"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "குறுங்கதை",
          "நாடகம்",
          "இலக்கணம்: வினைமுற்று, வினையெச்சம்",
          "இலக்கணம்: பெயரெச்சம்",
          "செவ்வியல் தமிழ்",
          "கட்டுரை",
          "கடிதம்",
          "மொழிப்பயிற்சி"
        ]
      }
    ],
    "9": [
      {
        "name": "Mathematics",
        "chapters": [
          "Set Language",
          "Real Numbers",
          "Algebra: Polynomials",
          "Geometry",
          "Coordinate Geometry",
          "Trigonometry",
          "Mensuration",
          "Statistics",
          "Probability",
          "Applied Mathematics"
        ]
      },
      {
        "name": "Science (Physics)",
        "chapters": [
          "Measurement",
          "Motion",
          "Fluids",
          "Electricity and Magnetism",
          "Acoustics",
          "Heat",
          "Light",
          "Universe"
        ]
      },
      {
        "name": "Science (Chemistry)",
        "chapters": [
          "Matter Around Us",
          "Atomic Structure",
          "Periodic Classification of Elements",
          "Water",
          "Carbon and Its Compounds"
        ]
      },
      {
        "name": "Science (Biology)",
        "chapters": [
          "Cell Biology",
          "Plant Physiology",
          "Animal Physiology",
          "Reproduction in Plants",
          "Reproduction in Animals",
          "Health and Hygiene",
          "Applied Biology",
          "Biotechnology"
        ]
      },
      {
        "name": "Social Science (History)",
        "chapters": [
          "French Revolution",
          "Industrial Revolution",
          "World After World War I",
          "World War II and Its Aftermath",
          "Colonial India",
          "Revolt of 1857",
          "Rise of Indian Nationalism",
          "Social Reform Movements in Tamil Nadu",
          "Independence and Partition",
          "Tamil Nadu After Independence"
        ]
      },
      {
        "name": "Social Science (Geography)",
        "chapters": [
          "Lithosphere",
          "Hydrosphere",
          "Atmosphere",
          "Biosphere",
          "India: Resources and Development",
          "India: Agriculture",
          "India: Industries",
          "India: Transport and Trade",
          "Population",
          "Environmental Issues"
        ]
      },
      {
        "name": "Social Science (Civics)",
        "chapters": [
          "Forms of Government",
          "Elections",
          "Political Parties",
          "Challenges to Democracy",
          "Human Rights",
          "United Nations"
        ]
      },
      {
        "name": "Social Science (Economics)",
        "chapters": [
          "Understanding Development",
          "Gross National Product",
          "Sectors of Economy",
          "Employment",
          "Poverty",
          "Food Security"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Prose: Adventure",
          "Prose: Science and Society",
          "Poetry: Nature and Values",
          "Grammar: Transformation",
          "Grammar: Synthesis",
          "Grammar: Voice and Narration",
          "Writing: Formal Letters",
          "Writing: Essays",
          "Comprehension"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "குறுங்கதை",
          "இலக்கணம்: மரபு",
          "இலக்கணம்: தொடர்",
          "செவ்வியல் தமிழ்",
          "கட்டுரை",
          "கடிதம்",
          "படவாசிப்பு",
          "ஒப்படைப்பு"
        ]
      }
    ],
    "10": [
      {
        "name": "Mathematics",
        "chapters": [
          "Relations and Functions",
          "Numbers and Sequences",
          "Algebra",
          "Geometry",
          "Coordinate Geometry",
          "Trigonometry",
          "Mensuration",
          "Statistics",
          "Probability"
        ]
      },
      {
        "name": "Science (Physics)",
        "chapters": [
          "Laws of Motion",
          "Optics",
          "Thermal Physics",
          "Electricity",
          "Acoustics",
          "Nuclear Physics"
        ]
      },
      {
        "name": "Science (Chemistry)",
        "chapters": [
          "Periodic Classification of Elements",
          "Chemical Reactions",
          "Acids, Bases and Salts",
          "Metals and Non-metals",
          "Carbon and Its Compounds"
        ]
      },
      {
        "name": "Science (Biology)",
        "chapters": [
          "Structural Organisation of Animals",
          "Plant Anatomy and Plant Physiology",
          "Nervous System",
          "Excretion",
          "Transportation in Plants and Circulation in Animals",
          "Reproduction in Plants",
          "Reproduction in Animals",
          "Genetics",
          "Evolution",
          "Environmental Issues"
        ]
      },
      {
        "name": "Social Science (History)",
        "chapters": [
          "Major Domains of the Earth",
          "The World Wars",
          "Post-War World",
          "India's Independence",
          "Government of India",
          "India and the World",
          "India's Economy",
          "Challenges to India's Democracy",
          "Social Issues"
        ]
      },
      {
        "name": "Social Science (Geography)",
        "chapters": [
          "Maps and Globes",
          "India: Location and Physical Features",
          "Climate of India",
          "Agriculture",
          "Industries",
          "Transport and Communication",
          "Population",
          "Trade and Commerce",
          "Environmental Issues in India"
        ]
      },
      {
        "name": "Social Science (Civics)",
        "chapters": [
          "Government at Union Level",
          "State Government",
          "Local Self-Government",
          "Law and Justice",
          "Human Rights",
          "International Organizations"
        ]
      },
      {
        "name": "Social Science (Economics)",
        "chapters": [
          "National Income",
          "Banking",
          "Public Finance",
          "Consumer Rights",
          "Poverty and Employment",
          "Globalisation"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Prose: Selected Texts",
          "Poetry: Selected Poems",
          "Drama/Short Story",
          "Grammar: All Structures",
          "Writing: Formal and Informal",
          "Comprehension: Unseen"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "குறுங்கதை",
          "இலக்கணம்: தொடர்",
          "செவ்வியல் தமிழ் – திருக்குறள்",
          "கட்டுரை",
          "கடிதம்",
          "மொழிப்பயிற்சி",
          "நேர்முகப் பேச்சு",
          "படவாசிப்பு"
        ]
      }
    ],
    "11": [
      {
        "name": "Mathematics",
        "chapters": [
          "Sets, Relations and Functions",
          "Basic Algebra",
          "Trigonometry",
          "Combinatorics and Mathematical Induction",
          "Binomial Theorem, Sequences and Series",
          "Two Dimensional Analytical Geometry",
          "Matrices and Determinants",
          "Vector Algebra",
          "Differential Calculus: Limits and Continuity",
          "Differential Calculus: Differentiability and Methods",
          "Integral Calculus",
          "Introduction to Probability Theory",
          "Statistics"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Nature of Physical World and Measurement",
          "Kinematics",
          "Laws of Motion",
          "Work, Energy and Power",
          "Motion of System of Particles and Rigid Bodies",
          "Gravitation",
          "Properties of Matter",
          "Heat and Thermodynamics",
          "Kinetic Theory of Gases",
          "Oscillations",
          "Waves"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Basic Concepts of Chemistry",
          "Quantum Mechanical Model of Atom",
          "Periodic Classification of Elements",
          "Hydrogen",
          "Alkali and Alkaline Earth Metals",
          "Gaseous State",
          "Thermodynamics",
          "Physical and Chemical Equilibrium",
          "Solutions",
          "Chemical Bonding",
          "Fundamentals of Organic Chemistry",
          "Basic Concepts of Organic Reactions",
          "Hydrocarbons",
          "Haloalkanes and Haloarenes",
          "Environmental Chemistry"
        ]
      },
      {
        "name": "Biology (Botany)",
        "chapters": [
          "Living World",
          "Plant Kingdom",
          "Vegetative Morphology",
          "Reproductive Morphology",
          "Taxonomy and Systematic Botany",
          "Cell Biology and Biomolecules",
          "Cell Division",
          "Tissue and Tissue System",
          "Transport in Plants",
          "Mineral Nutrition",
          "Photosynthesis",
          "Respiration",
          "Plant Growth and Development"
        ]
      },
      {
        "name": "Biology (Zoology)",
        "chapters": [
          "The Living World",
          "Kingdom Animalia",
          "Tissue Level of Organisation",
          "Organ and Organ Systems in Animals",
          "Digestion and Absorption",
          "Respiration in Animals",
          "Body Fluids and Circulation",
          "Excretion",
          "Locomotion and Movement",
          "Neural Control and Coordination",
          "Chemical Coordination"
        ]
      },
      {
        "name": "Accountancy",
        "chapters": [
          "Introduction to Accounting",
          "Conceptual Framework of Accounting",
          "Books of Prime Entry",
          "Ledger",
          "Trial Balance",
          "Subsidiary Books",
          "Bank Reconciliation Statement",
          "Final Accounts of Sole Proprietors",
          "Depreciation, Provisions and Reserves",
          "Accounts from Incomplete Records",
          "Computerised Accounting"
        ]
      },
      {
        "name": "Commerce",
        "chapters": [
          "Nature and Scope of Business",
          "Forms of Business Organisation",
          "Business Finance",
          "Banking Services",
          "Insurance",
          "Capital Market",
          "Consumer Protection",
          "International Trade",
          "IT in Commerce"
        ]
      },
      {
        "name": "Economics",
        "chapters": [
          "Introduction to Micro-Economics",
          "Consumer Behaviour",
          "Theory of Production",
          "Cost and Revenue Analysis",
          "Market Structure",
          "Pricing under Different Markets",
          "Introduction to Macro-Economics",
          "National Income",
          "Money and Credit",
          "Government Budget"
        ]
      },
      {
        "name": "Computer Science",
        "chapters": [
          "Introduction to Computers",
          "Number Systems",
          "Data Representation in Computers",
          "Computer Architecture",
          "Internet and Email",
          "Introduction to Python",
          "Control Flow",
          "Functions",
          "Strings and Lists",
          "Tuples, Sets and Dictionaries"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Prose: Selected Texts",
          "Poetry: Selected Poems",
          "Drama",
          "Vocabulary Building",
          "Grammar and Usage",
          "Writing Skills",
          "Comprehension"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "இலக்கணம்: எழுத்து, சொல், பொருள்",
          "செவ்வியல் தமிழ்",
          "திருக்குறள்",
          "சிலப்பதிகாரம்",
          "கட்டுரை",
          "கடிதம்",
          "மொழிப்பயிற்சி"
        ]
      }
    ],
    "12": [
      {
        "name": "Mathematics",
        "chapters": [
          "Applications of Matrices and Determinants",
          "Complex Numbers",
          "Theory of Equations",
          "Inverse Trigonometric Functions",
          "Two Dimensional Analytical Geometry – II",
          "Applications of Vector Algebra",
          "Applications of Differential Calculus",
          "Differentials and Partial Derivatives",
          "Applications of Integration",
          "Ordinary Differential Equations",
          "Probability Distributions",
          "Discrete Mathematics"
        ]
      },
      {
        "name": "Physics",
        "chapters": [
          "Electrostatics",
          "Current Electricity",
          "Magnetism and Magnetic Effects of Current",
          "Electromagnetic Induction and Alternating Current",
          "Electromagnetic Waves",
          "Ray Optics",
          "Wave Optics",
          "Dual Nature of Radiation and Matter",
          "Atomic and Nuclear Physics",
          "Electronics and Communication"
        ]
      },
      {
        "name": "Chemistry",
        "chapters": [
          "Metallurgy",
          "p-Block Elements – II",
          "d and f Block Elements",
          "Coordination Chemistry",
          "Solid State Chemistry",
          "Chemical Kinetics",
          "Electrochemistry – I and II",
          "Surface Chemistry",
          "Biomolecules",
          "Chemistry in Everyday Life",
          "Organic Nitrogen Compounds",
          "Carbonyl Compounds and Carboxylic Acids"
        ]
      },
      {
        "name": "Biology (Botany)",
        "chapters": [
          "Asexual and Sexual Reproduction in Plants",
          "Classical Genetics",
          "Chromosomal Basis of Inheritance",
          "Molecular Genetics",
          "Environmental Issues",
          "Principles and Processes of Biotechnology",
          "Plant Growth and Development",
          "Bio-Diversity",
          "Conservation Genetics"
        ]
      },
      {
        "name": "Biology (Zoology)",
        "chapters": [
          "Reproduction in Animals",
          "Endocrine System",
          "Nervous System",
          "Sense Organs",
          "Genetics",
          "Evolution",
          "Human Health and Diseases",
          "Applied Zoology",
          "Biotechnology and its Applications"
        ]
      },
      {
        "name": "Accountancy",
        "chapters": [
          "Accounts of Not-for-Profit Organisations",
          "Accounts of Partnership Firms: Fundamentals",
          "Goodwill in Partnership",
          "Admission of a Partner",
          "Retirement and Death of a Partner",
          "Dissolution of a Partnership Firm",
          "Issue of Shares",
          "Share Capital and Share Certificate",
          "Issue of Debentures",
          "Analysis of Financial Statements",
          "Cash Flow Statement"
        ]
      },
      {
        "name": "Commerce",
        "chapters": [
          "Management of Business Activities",
          "Entrepreneurship Development",
          "E-Commerce and Digital Payments",
          "Advertising and Marketing",
          "Business Ethics and Corporate Social Responsibility",
          "Legal Aspects of Business",
          "Startup Ecosystem",
          "International Business"
        ]
      },
      {
        "name": "Economics",
        "chapters": [
          "National Income",
          "Employment and Unemployment",
          "Money and Banking",
          "Fiscal Economics",
          "Balance of Payments",
          "Indian Economy: Agriculture",
          "Indian Economy: Industry",
          "Indian Economy: Service Sector",
          "Economic Reforms and Globalisation",
          "Tamil Nadu Economy"
        ]
      },
      {
        "name": "Computer Science",
        "chapters": [
          "Object Oriented Programming – Functions",
          "OOP Concepts in Python",
          "Exception Handling and File Handling",
          "Python Libraries – Pandas",
          "Python Libraries – Matplotlib",
          "Database Concepts",
          "RDBMS and SQL",
          "Networking",
          "Cyber Security and Ethics",
          "Project Development"
        ]
      },
      {
        "name": "English",
        "chapters": [
          "Prose: Selected Texts",
          "Poetry: Appreciation",
          "Drama",
          "Grammar: Transformation and Editing",
          "Writing: Essays, Articles, Speeches",
          "Letter and Applications",
          "Comprehension: Unseen"
        ]
      },
      {
        "name": "Tamil",
        "chapters": [
          "பாட்டு",
          "உரைநடை",
          "இலக்கணம்",
          "செவ்வியல் தமிழ்",
          "திருக்குறள்",
          "தொல்காப்பியம்",
          "கட்டுரை",
          "கடிதம்",
          "அபிதான விளக்கம்",
          "மொழி ஆய்வு"
        ]
      }
    ]
  }
};